import { integrationDesignMode } from "./design-mode";
import { applyIntegrationStyle } from "./integration-style";
import {
  requestHostSource,
  type SourceInputHandler,
} from "./host-source-request";
export {
  sourceRequestEvent,
  type SourceInputHandler,
  type SourceInputResult,
  type SourceRequestEventDetail,
} from "./host-source-request";
import {
  FormConfigurationSession,
  formConfiguration,
  type FormConfiguration,
} from "@proof/legacy";
import {
  formDataBindingsSchema,
  formDataRequests,
  applyFormData,
  type FormDataBinding,
  type FormDataProvider,
} from "./form-data";
export {
  formDataBindingsSchema,
  formDataRequests,
  applyFormData,
  type FormDataBinding,
  type FormDataProvider,
} from "./form-data";
import {
  BulkGeneration,
  bindBulkGenerationServices,
  bindBulkSessionStore,
  type BulkSessionStore,
  downloadBulkArtifact,
  type BulkGenerationServices,
  type BulkGenerationInput,
  type BulkBatchView,
  type BulkBatchDefinition,
  type BulkPreparedImages,
  type BulkDownload,
  type BulkGenerationProps,
  Configuration,
  Designer,
  Outputs,
  GlobalProfiles,
  FieldPresetLibrary,
  type GlobalProfilesProps,
  ProjectSummary,
  ConfigurationEditor,
  ProjectExport,
  DocumentImport,
  ProjectArchiveImport,
  type ProjectArchiveImportServices,
  ProjectRevisionReview,
  FontLibrary,
  AssetLibrary,
  bindAssetLibraryServices,
  downloadLibraryAsset,
  type AssetLibraryServices,
  type AssetLibraryArtifact,
  type AssetLibraryRecord,
  bindFontLibraryServices,
  downloadFontLibraryFace,
  type FontLibraryServices,
  type FontLibraryRecord,
  type FontLibraryArtifact,
  bindRevisionReviewServices,
  snapshotImportReport,
  downloadRevisionReview,
  type RevisionReviewServices,
  type RevisionReviewReport,
  downloadImportReport,
  downloadProjectPackage,
  parseConfiguration,
  type ConfigurationEditorProps,
  AuthoringSession,
  authoringStyles,
  type AuthoringServices,
  type ProjectSummaryProps,
  type ProjectExportServices,
  type ProjectExportArtifact,
  type DocumentImportServices,
  type DocumentImportProps,
} from "@proof/authoring";
export {
  FormConfigurationEditor,
  type FormConfigurationEditorProps,
} from "@proof/authoring";
export {
  FormConfigurationSession,
  formConfiguration,
  parseFormConfiguration,
  parsePageflexForm,
  readFormConfigurationUpload,
  type FormConfiguration,
} from "@proof/legacy";
export {
  ProofFormConfigurationElement,
  registerProofFormConfiguration,
} from "./form-configuration-element";
import React from "react";
import {
  authoringModes,
  integrationOptionsSchema,
  integrationThemeCss,
  type IntegrationOptions,
  type AuthoringMode,
} from "./integration-options";
export {
  authoringModes,
  integrationOptionsSchema,
} from "./integration-options";
export type { IntegrationOptions, AuthoringMode } from "./integration-options";
import type { HandoffInput, HandoffSummary } from "@proof/handoff";
import type { ApiContract } from "@proof/contracts";
export type { ApiContract } from "@proof/contracts";
export type { HandoffInput, HandoffSummary } from "@proof/handoff";
import type {
  PackageTarget,
  ProjectPackageReport,
  DamFormServices,
  DamBrowseInput,
  DamReadInput,
  DamPage,
  DamGenerated,
  DamProviderInfo,
} from "@proof/core";
import {
  assetResponse,
  requestHeaders,
  requestCredentials,
} from "./asset-transport";
import {
  FormPresentation,
  formDimension,
  formPresentationCss,
} from "./form-presentation";
import { createRoot, type Root } from "react-dom/client";
import { FormGenerator, ProofCanvas } from "@proof/ui";
export { BackgroundRemover, createBackgroundRemover } from "@proof/ui";
export type { BackgroundRemovalService } from "@proof/ui";
import {
  createBackgroundRemover,
  type BackgroundRemovalService,
} from "@proof/ui";
import {
  type FormImageServices,
  type AssetLoader,
  type FontLoader,
  type AssetInfo,
} from "@proof/ui";
import {
  parseProject,
  rebindPartValues,
  validateSubmission,
  parseContext,
  integrationDataQuerySchema,
  integrationDataValuesSchema,
  type IntegrationDataQuery,
  type Context,
  type Project,
  type ImportReport,
  type ImportResult,
  type ProjectArchiveUpload,
  type PlacedPdf,
  type Values,
  type OutputProfile,
  type FontFaceDescriptor,
  type TenantSettings,
  type SetupView,
  type SetupChange,
  type RoleChange,
  type AccountDecision,
  type AccountRequestList,
  type AccountRequestDetail,
  type AccountDecisionResult,
  type AccountRequestAudit,
  type DenialPage,
  type OperationSpec,
  type Assignment,
  type AuthorizationSnapshot,
  type RoleAudit,
  type Resource,
  type ResourceRef,
  type ResourceKind,
  resourceQuerySchema,
  type ResourceQuery,
  type MapFormServices,
  type MapSearchResult,
  type MapLocation,
  type MapGenerated,
  type Adjustments,
  type ProofRecord,
  type SourceParameters,
  applyHostSources,
  hostSourceRequests,
  type HostSourceData,
} from "@proof/core";
export {
  BulkGeneration,
  bindBulkGenerationServices,
  downloadBulkArtifact,
  FormGenerator,
  ProofCanvas,
  Configuration,
  Designer,
  Outputs,
  GlobalProfiles,
  FieldPresetLibrary,
  ProjectSummary,
  ConfigurationEditor,
  ProjectExport,
  downloadProjectPackage,
  DocumentImport,
  ProjectArchiveImport,
  downloadImportReport,
  FontLibrary,
  downloadFontLibraryFace,
  AssetLibrary,
  bindAssetLibraryServices,
  downloadLibraryAsset,
  AuthoringSession,
  authoringStyles,
};
export {
  assetLibraryRecordSchema,
  snapshotAssetLibraryRecords,
  attachLibraryAsset,
  detachLibraryAsset,
  readLibraryAsset,
} from "@proof/authoring";
export type {
  BulkGenerationProps,
  BulkGenerationServices,
  BulkGenerationInput,
  BulkContextInput,
  BulkBatchView,
  BulkJobView,
  BulkBatchDefinition,
  BulkPreparedImages,
  BulkDownload,
  BulkSessionStore,
  GlobalProfilesProps,
  AuthoringServices,
  ProjectSummaryProps,
  ConfigurationEditorProps,
  ConfigurationField,
  ConfigurationValue,
  ProjectExportProps,
  ProjectExportServices,
  ProjectExportArtifact,
  ProjectExportSelection,
  DocumentImportProps,
  DocumentImportServices,
  DocumentImportSelection,
  ProjectArchiveImportProps,
  ProjectArchiveImportServices,
  FontLibraryProps,
  AssetLibraryProps,
  AssetLibraryServices,
  AssetLibraryArtifact,
  AssetLibraryRecord,
  FontLibraryServices,
  FontLibraryRecord,
  FontLibraryArtifact,
} from "@proof/authoring";
export type { FormImageServices } from "@proof/ui";
export { ApiRepository } from "./api-repository";
export * from "@proof/core";
export function damFormServices(
  client: ProofClient,
  project: Project,
  partId?: string,
  versionId?: string,
): DamFormServices {
  const definition = parseProject(project),
    scope = {
      project: definition,
      projectId: definition.id,
      partId,
      versionId,
    };
  return {
    browse: (field, query, signal) =>
      client.browseDam({ ...scope, fieldId: field.id, query }, signal),
    select: (field, selection, signal) =>
      client.selectDam({ ...scope, fieldId: field.id, selection }, signal),
  };
}
export class ProofApiError extends Error {
  readonly name = "ProofApiError";
  constructor(
    message: string,
    readonly status: number,
    readonly code?: string,
    readonly retryAfterSeconds?: number,
  ) {
    super(message);
  }
}
export interface FormProfileScopeInput {
  sourceParameters?: SourceParameters;
  project?: Project;
  projectId?: string;
  versionId?: string;
  formId: string;
  demoProfile?: string;
  collection?: import("@proof/core").FormProfileCollectionKind;
}
export class ProofClient {
  profileDataset(
    resource: import("@proof/core").Resource,
    signal?: AbortSignal,
  ) {
    return this.request<import("@proof/core").ProfileDatasetView>(
      "/global-profile-datasets/query",
      {
        method: "POST",
        body: JSON.stringify({
          resourceId: resource.id,
          resourceVersion: resource.version,
          resource,
        }),
        signal,
      },
    );
  }
  saveProfileDataset(
    input: import("@proof/core").ProfileDatasetWrite,
    resource?: import("@proof/core").Resource,
    signal?: AbortSignal,
  ) {
    return this.request<import("@proof/core").ProfileDatasetView>(
      "/global-profile-datasets",
      { method: "PUT", body: JSON.stringify({ ...input, resource }), signal },
    );
  }
  predefinedProfileChoices(
    scope: FormProfileScopeInput & { instanceId: string },
    signal?: AbortSignal,
  ) {
    return this.request<{ id: string; name: string }[]>(
      "/global-profile-datasets/choices",
      { method: "POST", body: JSON.stringify(scope), signal },
    );
  }
  applyPredefinedProfile(
    scope: FormProfileScopeInput & { instanceId: string },
    recordId: string,
    values: Values,
    signal?: AbortSignal,
  ) {
    return this.request<{ values: Values }>("/global-profile-datasets/apply", {
      method: "POST",
      body: JSON.stringify({ ...scope, recordId, values }),
      signal,
    });
  }
  formProfileCatalog(
    query: import("@proof/core").FormProfileCatalogQuery = {},
    signal?: AbortSignal,
  ) {
    const params = new URLSearchParams();
    if (query.cursor !== undefined) params.set("cursor", query.cursor);
    if (query.limit !== undefined) params.set("limit", String(query.limit));
    return this.request<import("@proof/core").FormProfileCatalog>(
      `/form-profile-collections${params.size ? `?${params}` : ""}`,
      { signal },
    );
  }
  ownedFormProfile(collectionId: string, id: string, signal?: AbortSignal) {
    return this.request<import("@proof/core").FormProfileData>(
      `/form-profile-collections/${encodeURIComponent(collectionId)}/profiles/${encodeURIComponent(id)}`,
      { signal },
    );
  }
  manageFormProfile(
    collectionId: string,
    id: string,
    input: import("@proof/core").FormProfileManage,
    signal?: AbortSignal,
  ) {
    return this.request<
      import("@proof/core").FormProfileCatalog["collections"][number]["profiles"][number]
    >(
      `/form-profile-collections/${encodeURIComponent(collectionId)}/profiles/${encodeURIComponent(id)}`,
      { method: "PUT", body: JSON.stringify(input), signal },
    );
  }
  removeOwnedFormProfile(
    collectionId: string,
    id: string,
    expectedRevision: number,
    signal?: AbortSignal,
  ) {
    return this.request<void>(
      `/form-profile-collections/${encodeURIComponent(collectionId)}/profiles/${encodeURIComponent(id)}`,
      { method: "DELETE", body: JSON.stringify({ expectedRevision }), signal },
    );
  }
  listFormProfiles(scope: FormProfileScopeInput, signal?: AbortSignal) {
    return this.request<{
      definitionHash: string;
      durable: boolean;
      collection: import("@proof/core").FormProfileCollectionKind;
      library?: import("@proof/core").FormProfileLibrary;
      profiles: import("@proof/core").FormProfile[];
      sharingEnabled: boolean;
      sharing: Record<string, string[]>;
      sharedProfiles: import("@proof/core").SharedFormProfileSummary[];
      context: Context;
    }>("/form-profiles/query", {
      method: "POST",
      body: JSON.stringify(scope),
      signal,
    });
  }
  createFormProfile(
    scope: FormProfileScopeInput,
    profile: import("@proof/core").FormProfileInput,
    signal?: AbortSignal,
  ) {
    return this.request<import("@proof/core").FormProfile>("/form-profiles", {
      method: "POST",
      body: JSON.stringify({ ...scope, profile }),
      signal,
    });
  }
  shareFormProfile(
    scope: FormProfileScopeInput,
    id: string,
    sharing: import("@proof/core").FormProfileSharing,
    signal?: AbortSignal,
  ) {
    return this.request<{
      profile: import("@proof/core").FormProfile;
      recipients: string[];
    }>(`/form-profiles/${encodeURIComponent(id)}/sharing`, {
      method: "PUT",
      body: JSON.stringify({ ...scope, sharing }),
      signal,
    });
  }
  readSharedFormProfile(
    scope: FormProfileScopeInput,
    owner: string,
    id: string,
    signal?: AbortSignal,
  ) {
    return this.request<{
      profile: import("@proof/core").FormProfile;
      context: Context;
    }>(`/form-profiles/${encodeURIComponent(id)}/shared`, {
      method: "POST",
      body: JSON.stringify({ ...scope, owner }),
      signal,
    });
  }
  updateFormProfile(
    scope: FormProfileScopeInput,
    id: string,
    profile: import("@proof/core").FormProfileUpdate,
    signal?: AbortSignal,
  ) {
    return this.request<import("@proof/core").FormProfile>(
      `/form-profiles/${encodeURIComponent(id)}`,
      { method: "PUT", body: JSON.stringify({ ...scope, profile }), signal },
    );
  }
  deleteFormProfile(
    scope: FormProfileScopeInput,
    id: string,
    expectedRevision: number,
    signal?: AbortSignal,
  ) {
    return this.request<void>(`/form-profiles/${encodeURIComponent(id)}`, {
      method: "DELETE",
      body: JSON.stringify({ ...scope, profile: { expectedRevision } }),
      signal,
    });
  }
  apiContract(signal?: AbortSignal) {
    return this.request<ApiContract>("/openapi.json", { signal });
  }
  constructor(
    public baseUrl = "",
    public headers: Record<string, string> = {},
  ) {
    this.baseUrl = baseUrl.replace(/\/+$/, "");
  }
  async request<T>(
    path: string,
    options: RequestInit = {},
    responseType: "json" | "blob" = "json",
  ): Promise<T> {
    const response = await fetch(`${this.baseUrl}/api${path}`, {
      redirect: "error",
      credentials: requestCredentials(this.headers),
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...this.headers,
        ...options.headers,
      },
    });
    if (!response.ok) {
      const problem = (await response.json().catch(() => ({}))) as {
        error?: unknown;
        code?: unknown;
      };
      const header = response.headers.get("Retry-After"),
        seconds = header === null ? undefined : Number(header);
      throw new ProofApiError(
        typeof problem.error === "string" ? problem.error : response.statusText,
        response.status,
        typeof problem.code === "string" ? problem.code : undefined,
        seconds !== undefined && Number.isFinite(seconds) && seconds >= 0
          ? seconds
          : undefined,
      );
    }
    return response.status === 204
      ? (undefined as T)
      : responseType === "blob"
        ? ((await response.blob()) as T)
        : response.json();
  }
  securityAudit(before?: string, limit = 50) {
    const query = new URLSearchParams({ limit: String(limit) });
    if (before) query.set("before", before);
    return this.request<DenialPage & { healthy: boolean }>(
      `/security-audit?${query}`,
    );
  }
  operationPolicy() {
    return this.request<{
      version: 1;
      operations: OperationSpec[];
      limits: {
        global: number;
        mutation: number;
        artifact: number;
        windowMs: number;
      };
    }>("/operation-policy");
  }
  searchMap(query: string, signal?: AbortSignal) {
    return this.request<MapSearchResult>("/maps/search", {
      method: "POST",
      body: JSON.stringify({ query }),
      signal,
    });
  }
  listDamProviders(signal?: AbortSignal) {
    return this.request<DamProviderInfo[]>("/dam/providers", { signal });
  }
  browseDam(
    input: {
      project?: Project;
      projectId?: string;
      versionId?: string;
      partId?: string;
      fieldId: string;
      query: DamBrowseInput;
    },
    signal?: AbortSignal,
  ) {
    return this.request<DamPage>("/dam/browse", {
      method: "POST",
      body: JSON.stringify(input),
      signal,
    });
  }
  selectDam(
    input: {
      project?: Project;
      projectId?: string;
      versionId?: string;
      partId?: string;
      fieldId: string;
      selection: DamReadInput;
    },
    signal?: AbortSignal,
  ) {
    return this.request<DamGenerated>("/dam/select", {
      method: "POST",
      body: JSON.stringify(input),
      signal,
    });
  }
  createMap(
    input: {
      project?: Project;
      projectId?: string;
      versionId?: string;
      partId?: string;
      fieldId: string;
      location: MapLocation;
      providerId: string;
    },
    signal?: AbortSignal,
  ) {
    return this.request<MapGenerated>("/maps/create", {
      method: "POST",
      body: JSON.stringify(input),
      signal,
    });
  }
  accountRequests() {
    return this.request<AccountRequestList>("/account-requests");
  }
  accountRequest(id: string) {
    return this.request<AccountRequestDetail>(
      `/account-requests/${encodeURIComponent(id)}`,
    );
  }
  decideAccountRequest(id: string, decision: AccountDecision) {
    return this.request<AccountDecisionResult>(
      `/account-requests/${encodeURIComponent(id)}/decision`,
      { method: "POST", body: JSON.stringify(decision) },
    );
  }
  accountRequestAudit() {
    return this.request<AccountRequestAudit[]>("/account-request-audit");
  }
  createDemoAccountRequest() {
    return this.request<AccountRequestDetail>("/demo/account-requests", {
      method: "POST",
      body: "{}",
    });
  }
  tenantAccess() {
    return this.request<{
      version: 1;
      stateRevision: number;
      assignments: Assignment[];
      current: AuthorizationSnapshot;
    }>("/tenant-access");
  }
  previewUsers(signal?: AbortSignal) {
    return this.request<{ id: string; name: string }[]>(
      "/proof-preview/users",
      { signal },
    );
  }
  replaceRoles(change: RoleChange) {
    return this.request<{ assignment: Assignment; stateRevision: number }>(
      "/tenant-access/roles",
      { method: "PUT", body: JSON.stringify(change) },
    );
  }
  accessAudit() {
    return this.request<RoleAudit[]>("/tenant-access/audit");
  }
  setup() {
    return this.request<SetupView>("/setup");
  }
  changeSetup(change: SetupChange) {
    return this.request<SetupView>("/setup", {
      method: "POST",
      body: JSON.stringify(change),
    });
  }
  startProjectArchive(
    input: { filename: string; bytes: number },
    signal?: AbortSignal,
  ) {
    return this.request<ProjectArchiveUpload>("/project-archives", {
      method: "POST",
      body: JSON.stringify(input),
      signal,
    });
  }
  projectArchive(id: string, signal?: AbortSignal) {
    return this.request<ProjectArchiveUpload>(
      `/project-archives/${encodeURIComponent(id)}`,
      { signal },
    );
  }
  uploadProjectArchiveChunk(
    id: string,
    offset: number,
    chunk: Blob,
    signal?: AbortSignal,
  ) {
    return this.request<ProjectArchiveUpload>(
      `/project-archives/${encodeURIComponent(id)}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/octet-stream",
          "X-Upload-Offset": String(offset),
        },
        body: chunk,
        signal,
      },
    );
  }
  importArchiveProject(
    id: string,
    entryId: string,
    template?: string,
    signal?: AbortSignal,
  ) {
    return this.request<ImportResult>(
      `/project-archives/${encodeURIComponent(id)}/projects`,
      { method: "POST", body: JSON.stringify({ entryId, template }), signal },
    );
  }
  removeProjectArchive(id: string, signal?: AbortSignal) {
    return this.request<{ removed: boolean }>(
      `/project-archives/${encodeURIComponent(id)}`,
      { method: "DELETE", signal },
    );
  }
  importDocument(
    file: Blob,
    filename: string,
    signal?: AbortSignal,
    options: { packageContent?: "native" | "edited-idml" } = {},
  ) {
    return this.request<ImportResult>(
      `/documents/import${options.packageContent ? `?packageContent=${encodeURIComponent(options.packageContent)}` : ""}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/octet-stream",
          "X-Filename": encodeURIComponent(filename),
        },
        body: file,
        signal,
      },
    );
  }
  projectPackageReport(
    project: Project,
    signal?: AbortSignal,
    options: { target?: PackageTarget; partId?: string } = {},
  ) {
    return this.request<ProjectPackageReport>("/documents/package/report", {
      method: "POST",
      body: JSON.stringify({ project, ...options }),
      signal,
    });
  }
  exportProjectPackage(
    project: Project,
    signal?: AbortSignal,
    options: { target?: PackageTarget; partId?: string } = {},
  ) {
    return this.request<Blob>(
      "/documents/package",
      { method: "POST", body: JSON.stringify({ project, ...options }), signal },
      "blob",
    );
  }
  listFonts(signal?: AbortSignal) {
    return this.request<FontLibraryRecord[]>("/fonts", { signal });
  }
  uploadFont(file: Blob, filename: string, signal?: AbortSignal) {
    return this.request<FontLibraryRecord>("/fonts", {
      method: "POST",
      headers: {
        "Content-Type": "application/octet-stream",
        "X-Filename": encodeURIComponent(filename),
      },
      body: file,
      signal,
    });
  }
  archiveFont(id: string, signal?: AbortSignal) {
    return this.request<FontLibraryRecord>(
      `/fonts/${encodeURIComponent(id)}/archive`,
      { method: "POST", signal },
    );
  }
  uploadAsset(
    file: Blob,
    filename: string,
    signal?: AbortSignal,
    projectId?: string,
  ) {
    return this.request<AssetInfo>(
      `/assets${projectId ? `?projectId=${encodeURIComponent(projectId)}` : ""}`,
      {
        method: "POST",
        body: file,
        signal,
        headers: {
          "Content-Type": file.type || "application/octet-stream",
          "X-Filename": encodeURIComponent(filename),
        },
      },
    );
  }
  importPdfArtwork(
    file: Blob,
    filename: string,
    page = 1,
    signal?: AbortSignal,
  ) {
    return this.request<PlacedPdf>(`/assets/pdf?page=${page}`, {
      method: "POST",
      body: file,
      signal,
      headers: {
        "Content-Type": "application/pdf",
        "X-Filename": encodeURIComponent(filename),
      },
    });
  }
  listAssets(signal?: AbortSignal, projectId?: string) {
    return this.request<AssetInfo[]>(
      `/assets${projectId ? `?projectId=${encodeURIComponent(projectId)}` : ""}`,
      { signal },
    );
  }
  async loadAsset(id: string, signal?: AbortSignal) {
    const response = await fetch(
      `${this.baseUrl}/api/assets/${encodeURIComponent(id)}`,
      {
        headers: { ...this.headers },
        signal,
        credentials: requestCredentials(this.headers),
        redirect: "error",
      },
    );
    return assetResponse(response);
  }
  async transformAsset(
    id: string,
    adjustments: Adjustments,
    signal?: AbortSignal,
  ) {
    const response = await fetch(
      `${this.baseUrl}/api/assets/${encodeURIComponent(id)}/transform`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", ...this.headers },
        body: JSON.stringify({ adjustments }),
        credentials: requestCredentials(this.headers),
        redirect: "error",
        signal,
      },
    );
    if (!response.ok) {
      await response.body?.cancel().catch(() => undefined);
      throw new ProofApiError("IMAGE_PREVIEW_UNAVAILABLE", response.status);
    }
    return assetResponse(response);
  }
  fontUrl(id: string) {
    return `${this.baseUrl}/api/fonts/${encodeURIComponent(id)}/file`;
  }
  async loadFont(
    face: FontFaceDescriptor,
    signal?: AbortSignal,
    maxBytes = 8000000,
  ) {
    if (!Number.isSafeInteger(maxBytes) || maxBytes < 20 || maxBytes > 64000000)
      throw new TypeError("Choose a managed font byte limit up to 64 MB");
    const blob = await this.request<Blob>(
      `/fonts/${encodeURIComponent(face.id)}/file`,
      { signal },
      "blob",
    );
    if (blob.size > maxBytes)
      throw new ProofApiError("FONT_PREVIEW_UNAVAILABLE", 413);
    return new Uint8Array(await blob.arrayBuffer());
  }
  getTenantSettings() {
    return this.request<TenantSettings>("/tenant-settings");
  }
  saveTenantSettings(settings: TenantSettings) {
    return this.request<TenantSettings>("/tenant-settings", {
      method: "PUT",
      body: JSON.stringify({ settings, expectedRevision: settings.revision }),
    });
  }
  listFieldPresets(query: import("@proof/core").FieldPresetQuery = {}) {
    const params = new URLSearchParams(
      Object.entries(query).filter(
        (e): e is [string, string] => typeof e[1] === "string",
      ),
    );
    return this.request<import("@proof/core").FieldPresetCatalog>(
      `/field-presets${params.size ? `?${params}` : ""}`,
    );
  }
  saveFieldPreset(input: import("@proof/core").FieldPresetWrite) {
    return this.request<import("@proof/core").FieldPreset>("/field-presets", {
      method: "POST",
      body: JSON.stringify(input),
    });
  }
  listResources(query: ResourceQuery = {}) {
    const params = new URLSearchParams(
      Object.entries(resourceQuerySchema.parse(query)).filter(
        (entry): entry is [string, string] => typeof entry[1] === "string",
      ),
    );
    return this.request<Resource[]>(
      `/resources${params.size ? `?${params}` : ""}`,
    );
  }
  saveResource(resource: Resource) {
    return this.request<Resource>("/resources", {
      method: "POST",
      body: JSON.stringify({ ...resource, expectedVersion: resource.version }),
    });
  }
  archiveResource(id: string, archived: boolean) {
    return this.request(`/resources/${encodeURIComponent(id)}/archive`, {
      method: "PUT",
      body: JSON.stringify({ archived }),
    });
  }
  createProject(
    project: unknown,
    resources?: Partial<Record<ResourceKind, ResourceRef>>,
    useDefaults = true,
  ) {
    return this.request<Project>("/projects", {
      method: "POST",
      body: JSON.stringify({ project, resources, useDefaults }),
    });
  }
  lockRevision(projectId: string, revisionId: string, locked: boolean) {
    return this.request(
      `/projects/${encodeURIComponent(projectId)}/history/${encodeURIComponent(revisionId)}/lock`,
      { method: "PUT", body: JSON.stringify({ locked }) },
    );
  }
  listProjects() {
    return this.request<Project[]>("/projects");
  }
  getProject(id: string) {
    return this.request<Project>(`/projects/${encodeURIComponent(id)}`);
  }
  listProofs(projectId: string, signal?: AbortSignal) {
    return this.request<ProofRecord[]>(
      `/projects/${encodeURIComponent(projectId)}/proofs`,
      { signal },
    );
  }
  getProof(projectId: string, proofId: string, signal?: AbortSignal) {
    return this.request<ProofRecord>(
      `/projects/${encodeURIComponent(projectId)}/proofs/${encodeURIComponent(proofId)}`,
      { signal },
    );
  }
  saveProof(
    projectId: string,
    input: {
      versionId?: string;
      partId?: string;
      values: Values;
      name?: string;
      comments?: string;
      accepted?: boolean;
      initials?: string;
      contextHash?: string;
      sourceParameters?: SourceParameters;
      demoProfile?: "alex" | "jamie" | "guest";
    },
    signal?: AbortSignal,
  ) {
    return this.request<ProofRecord>(
      `/projects/${encodeURIComponent(projectId)}/proofs`,
      {
        method: "POST",
        body: JSON.stringify(input),
        signal,
      },
    );
  }
  saveProject(project: Project) {
    return this.request<Project>(
      `/projects/${encodeURIComponent(project.id)}`,
      {
        method: "PUT",
        body: JSON.stringify({ project, expectedRevision: project.revision }),
      },
    );
  }
  publish(id: string) {
    return this.request(`/projects/${encodeURIComponent(id)}/publish`, {
      method: "POST",
    });
  }
  async queryIntegrationData(
    input: IntegrationDataQuery,
    signal?: AbortSignal,
  ) {
    const query = integrationDataQuerySchema.parse(input);
    const response = await this.request<{
      version: 1;
      sourceId: string;
      recordId: string;
      values: Record<string, unknown>;
    }>("/integration-data/query", {
      method: "POST",
      body: JSON.stringify(query),
      signal,
      credentials: "omit",
    });
    if (
      response.version !== 1 ||
      response.sourceId !== query.sourceId ||
      response.recordId !== query.recordId ||
      query.fields.some((key) => !Object.hasOwn(response.values, key)) ||
      Object.keys(response.values).some((key) => !query.fields.includes(key))
    )
      throw Error("Invalid integration data response");
    return {
      ...response,
      values: integrationDataValuesSchema.parse(response.values),
    };
  }
  previewContext(
    input: {
      projectId?: string;
      versionId?: string;
      project?: Project;
      partId?: string;
      demoProfile?: "alex" | "jamie" | "guest";
      sourceParameters?: SourceParameters;
      forceRefresh?: boolean;
    },
    signal?: AbortSignal,
  ) {
    return this.request<{ version: 1; context: Context; hash?: string }>(
      "/context-preview",
      {
        method: "POST",
        body: JSON.stringify(input),
        signal,
      },
    );
  }
  generate(
    projectId: string,
    versionId: string,
    values: Values,
    profileId: string,
    partId?: string,
    contextHash?: string,
    sourceParameters?: SourceParameters,
    generationOptions: {
      duplicatePolicy?: "confirm";
      replaceJobId?: string;
    } = {},
  ) {
    return this.request<{
      id: string;
      state: string;
      duplicate?: boolean;
      replacesJobId?: string;
    }>("/jobs", {
      method: "POST",
      body: JSON.stringify({
        projectId,
        versionId,
        values,
        profileId,
        partId,
        contextHash,
        sourceParameters,
        ...generationOptions,
      }),
    });
  }
  generateDemo(
    project: Project,
    values: Values,
    profile: OutputProfile,
    partId?: string,
    contextOptions: {
      contextHash?: string;
      sourceParameters?: SourceParameters;
      demoProfile?: "alex" | "jamie" | "guest";
      duplicatePolicy?: "confirm";
      replaceJobId?: string;
    } = {},
  ) {
    return this.request<{
      id: string;
      state: string;
      duplicate?: boolean;
      replacesJobId?: string;
    }>("/jobs", {
      method: "POST",
      body: JSON.stringify({
        project,
        values,
        profile,
        partId,
        ...contextOptions,
      }),
    });
  }
  job(id: string) {
    return this.request<{
      id: string;
      state: string;
      stateVersion: number;
      attempts: number;
      error?: string;
      artifact?: unknown;
    }>(`/jobs/${encodeURIComponent(id)}`);
  }
  createBatch(
    project: Project,
    profile: OutputProfile,
    batch: import("@proof/core").BulkRequest,
    partId?: string,
    contextOptions: {
      contextHash?: string;
      sourceParameters?: SourceParameters;
      demoProfile?: "alex" | "jamie" | "guest";
    } = {},
  ) {
    return this.request<{ id: string; state: string; stateVersion: number }>(
      "/batches",
      {
        method: "POST",
        body: JSON.stringify({
          project,
          profile,
          partId,
          batch,
          ...contextOptions,
        }),
      },
    );
  }
  prepareProjectImages(project: Project, signal?: AbortSignal) {
    return this.request<Project>("/documents/image-urls", {
      method: "POST",
      body: JSON.stringify({ project }),
      signal,
    });
  }
  prepareBatchImages(
    input: {
      project?: Project;
      projectId?: string;
      versionId?: string;
      profile?: OutputProfile;
      profileId?: string;
      batch: import("@proof/core").BulkRequest;
      partId?: string;
      contextHash?: string;
      sourceParameters?: SourceParameters;
      demoProfile?: "alex" | "jamie" | "guest";
    },
    signal?: AbortSignal,
  ) {
    return this.request<{
      rows: {
        sourceRow: number;
        values: Values;
        diagnostics: { fieldId?: string; code: string; message: string }[];
      }[];
    }>("/batches/prepare", {
      method: "POST",
      body: JSON.stringify(input),
      signal,
    });
  }
  createPublishedBatch(
    projectId: string,
    versionId: string,
    profileId: string,
    batch: import("@proof/core").BulkRequest,
    partId?: string,
    contextHash?: string,
    sourceParameters?: SourceParameters,
  ) {
    return this.request<{ id: string; state: string; stateVersion: number }>(
      "/batches",
      {
        method: "POST",
        body: JSON.stringify({
          projectId,
          versionId,
          profileId,
          partId,
          batch,
          contextHash,
          sourceParameters,
        }),
      },
    );
  }
  batch(id: string) {
    return this.request<{
      id: string;
      state: string;
      stateVersion: number;
      progress: { total: number; processed: number; percent: number };
      rows: unknown[];
    }>(`/batches/${encodeURIComponent(id)}`);
  }
  cancelBatch(
    id: string,
    stateVersion: number,
    reason: string,
    cleanup = false,
  ) {
    return this.request<{ id: string; state: string; stateVersion: number }>(
      `/batches/${encodeURIComponent(id)}/${cleanup ? "cleanup" : "cancel"}`,
      { method: "POST", body: JSON.stringify({ stateVersion, reason }) },
    );
  }
  retryBatchRows(
    id: string,
    stateVersion: number,
    rowKeys: string[],
    reason: string,
  ) {
    return this.request<{ id: string; state: string; stateVersion: number }>(
      `/batches/${encodeURIComponent(id)}/retry`,
      {
        method: "POST",
        body: JSON.stringify({ stateVersion, rowKeys, reason }),
      },
    );
  }
  renderOperations() {
    return this.request<
      {
        id: string;
        state: string;
        stateVersion: number;
        attempts: number;
        error?: string;
        artifact?: unknown;
      }[]
    >("/render-operations");
  }
  operateJob(
    id: string,
    action: "retry" | "cancel",
    stateVersion: number,
    reason: string,
    probation = false,
  ) {
    return this.request<{ id: string; state: string; stateVersion: number }>(
      `/render-operations/${encodeURIComponent(id)}/${action}`,
      {
        method: "POST",
        body: JSON.stringify({
          stateVersion,
          reason,
          ...(action === "retry" ? { probation } : {}),
        }),
      },
    );
  }
  cancelJob(id: string, stateVersion: number, reason: string) {
    return this.request<{ id: string; state: string; stateVersion: number }>(
      `/jobs/${encodeURIComponent(id)}/cancel`,
      { method: "POST", body: JSON.stringify({ stateVersion, reason }) },
    );
  }
  retryJob(
    id: string,
    stateVersion: number,
    reason: string,
    probation = false,
  ) {
    return this.request<{ id: string; state: string; stateVersion: number }>(
      `/jobs/${encodeURIComponent(id)}/retry`,
      {
        method: "POST",
        body: JSON.stringify({ stateVersion, reason, probation }),
      },
    );
  }
  async loadGenerationArtifact(id: string, signal?: AbortSignal) {
    const response = await fetch(this.artifactUrl(id), {
      headers: { ...this.headers },
      credentials: requestCredentials(this.headers),
      redirect: "error",
      signal,
    });
    if (
      !response.ok ||
      !response.body ||
      Number(response.headers.get("content-length")) > 200000000
    ) {
      await response.body?.cancel();
      throw new Error("Generation artifact is unavailable");
    }
    const reader = response.body.getReader(),
      chunks: BlobPart[] = [];
    let size = 0;
    try {
      for (;;) {
        const next = await reader.read();
        if (next.done) break;
        size += next.value.byteLength;
        if (size > 200000000)
          throw new Error("Generation artifact exceeds 200 MB");
        chunks.push(new Uint8Array(next.value));
        signal?.throwIfAborted();
      }
    } finally {
      await reader.cancel().catch(() => {});
      reader.releaseLock();
    }
    signal?.throwIfAborted();
    return new Blob(chunks, {
      type: response.headers.get("content-type")?.split(";")[0] || "",
    });
  }
  artifactUrl(id: string) {
    return `${this.baseUrl}/api/jobs/${encodeURIComponent(id)}/artifact`;
  }
  createHandoff(input: HandoffInput, signal?: AbortSignal) {
    return this.request<HandoffSummary>("/handoffs", {
      method: "POST",
      body: JSON.stringify(input),
      signal,
    });
  }
  handoffDeliveryStatus(signal?: AbortSignal) {
    return this.request<import("@proof/core").HandoffDeliveryStatus>(
      "/handoff-delivery",
      { signal },
    );
  }
  deliverHandoff(
    id: string,
    input: import("@proof/core").HandoffDeliveryInput,
    signal?: AbortSignal,
  ) {
    return this.request<import("@proof/core").HandoffDeliveryResult>(
      `/handoffs/${encodeURIComponent(id)}/delivery`,
      {
        method: "POST",
        body: JSON.stringify(input),
        signal,
      },
    );
  }
  listHandoffs(
    options: { projectId?: string; cursor?: string; limit?: number } = {},
    signal?: AbortSignal,
  ) {
    const query = new URLSearchParams();
    if (options.projectId) query.set("projectId", options.projectId);
    if (options.cursor) query.set("cursor", options.cursor);
    if (options.limit !== undefined) query.set("limit", String(options.limit));
    return this.request<{
      records: HandoffSummary[];
      nextCursor?: string;
      storage: { durable: boolean; artifactDurable: boolean };
    }>(`/handoffs${query.size ? `?${query}` : ""}`, { signal });
  }
  getHandoff(id: string, signal?: AbortSignal) {
    return this.request<HandoffSummary>(`/handoffs/${encodeURIComponent(id)}`, {
      signal,
    });
  }
  handoffUrl(id: string) {
    return `${this.baseUrl}/api/handoffs/${encodeURIComponent(id)}/package`;
  }
}
const componentCss = `.image-field-actions{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px}:host{display:block;font:14px system-ui;color:#183c3c}*{box-sizing:border-box}button,input,select,textarea{font:inherit}input:not([type=checkbox]):not([type=radio]),select,textarea{width:100%;padding:10px;border:1px solid #d7dfda;border-radius:6px;margin:6px 0}button{padding:8px 12px;cursor:pointer}label{display:block}fieldset{border:0;padding:0}.form-field{margin-bottom:16px}input.numeric,input[type=number]{text-align:right;font-variant-numeric:tabular-nums}.form-group h3{font-size:16px}.field-help{color:#66776d}.error-text{color:#ab3028}.computed-field{padding:10px;background:#f4f7f3}.field-tag{font-size:11px;margin-left:8px}.asset-thumbnail{max-height:100px;max-width:100%}.upload-zone{border:1px dashed #9eafa1;padding:12px}.upload-zone input{display:block}.form-tabs{display:flex;gap:6px;flex-wrap:wrap}.proof-canvas{display:block}.sr-only{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0)}.canvas-shell{margin-top:16px;max-width:100%;overflow:auto}.image-tools label{margin:8px 0}.searchable-select{position:relative;width:100%}.searchable-select-trigger{display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;min-height:40px;padding:10px;border:1px solid #d7dfda;border-radius:6px;margin:6px 0;background:#fff;color:inherit;text-align:left;cursor:pointer}.searchable-select-trigger.native{display:block;appearance:auto}.searchable-select-trigger>span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.searchable-select-popover{position:absolute;top:calc(100% - 2px);left:0;right:0;z-index:40;background:#fff;border:1px solid #d7dfda;border-radius:6px;box-shadow:0 6px 16px rgb(20 30 25/.12);overflow:hidden}.searchable-select-search{display:flex;align-items:center;gap:8px;padding:6px 10px;border-bottom:1px solid #e6e9e9}.searchable-select .searchable-select-search input[type=search]{border:0;margin:0;padding:4px 0;outline:none;flex:1}.searchable-select-list{overflow-y:auto;overscroll-behavior:contain}.searchable-select-option{display:flex;flex-direction:column;justify-content:center;padding:0 12px;cursor:pointer;overflow:hidden}.searchable-select-option>small{color:#66776d;font-size:11px}.searchable-select-option.active{background:#eef1ef}.searchable-select-option[aria-selected=true]{font-weight:600}.searchable-select-status,.searchable-select-count{margin:0;padding:8px 12px;font-size:12px;color:#66776d}`;
const formControlsCss = `
.proof-form{container-type:inline-size}
.form-groups{display:grid;gap:20px}
.form-section-column{display:flex;flex-direction:column;gap:20px;min-width:0}
.form-group{min-width:0}
.form-group.ungrouped{grid-column:1/-1}
@container (max-width:600px){.form-groups{display:block}}
.form-field>.form-field-label{display:block;margin-bottom:6px}
.proof-form .form-field input:disabled,.proof-form .form-field select:disabled,.proof-form .form-field textarea:disabled{background-color:#eef1ef;border-color:#d6ddd9;color:#5e6b64;-webkit-text-fill-color:currentColor;opacity:1;cursor:not-allowed}
.dynamic-source-parameters{display:flex;align-items:center;flex-wrap:wrap;gap:8px;margin-bottom:16px}
.dynamic-source-parameters .button{border:1px solid #d7dfda;border-radius:6px;background:#fff;color:inherit;line-height:1.5}
.dynamic-source-parameters .button:hover{background:#f4f7f3}
.dynamic-source-parameters .button.primary{background:#47735d;border-color:#47735d;color:#fff}
.dynamic-source-parameters dialog{color:inherit}
.dynamic-source-parameters dialog::backdrop{background:#20382f55}
.dynamic-source-parameters dialog section{padding-top:16px}
.dynamic-source-parameters dialog fieldset{min-width:0;margin:0;padding:12px 0 0}
`;
const ElementBase =
  typeof HTMLElement === "undefined"
    ? (class {} as unknown as typeof HTMLElement)
    : HTMLElement;
class IntegrationElement extends ElementBase {
  protected integration = integrationOptionsSchema.parse({});
  private colorScheme?: MediaQueryList;
  private updateColorScheme = () => this.configurationChanged();
  set options(value: IntegrationOptions) {
    this.integration = integrationOptionsSchema.parse(value);
    this.configurationChanged();
  }
  get options(): IntegrationOptions {
    return structuredClone(this.integration);
  }
  protected configurationChanged() {}
  protected connectIntegration() {
    this.colorScheme = window.matchMedia("(prefers-color-scheme: dark)");
    this.colorScheme.addEventListener("change", this.updateColorScheme);
  }
  protected disconnectIntegration() {
    this.colorScheme?.removeEventListener("change", this.updateColorScheme);
  }
  protected applyIntegrationTheme() {
    if (!this.shadowRoot) return;
    applyIntegrationStyle(this, this.integration, !!this.colorScheme?.matches);
    const mount = this.shadowRoot.querySelector<HTMLDivElement>("div");
    if (mount)
      mount.dataset.proofDisabled = String(!this.integration.permissions.proof);
  }
}
export class ProofFormElement extends IntegrationElement {
  private bindings: FormDataBinding[] = [];
  private provider?: FormDataProvider;
  private dataController?: AbortController;
  private dataEpoch = 0;
  private dataParameters: Record<string, Record<string, unknown>> = {};
  private dataLoading = false;
  private dataError = "";
  // Host source inputs ("Use Source Input" fields).
  private sourceHandler?: SourceInputHandler;
  private sourceKey = "";
  private sourceController?: AbortController;
  private sourceLoading = false;
  private sourceErrors: Record<string, string> = {};
  private sourceResults: Record<string, HostSourceData> = {};
  /** Optional callback alternative to the proof:source-request event. */
  set sourceInputHandler(value: SourceInputHandler | undefined) {
    this.sourceHandler = value;
    this.sourceKey = "";
    this.render();
  }
  get sourceInputHandler() {
    return this.sourceHandler;
  }
  /** Re-request every host source input (for example after a host change). */
  refreshSourceInputs() {
    this.sourceKey = "";
    this.render();
  }
  private loadSourceInputs(project: Project) {
    const requests = this.integration.sourceInputs
      ? hostSourceRequests(project)
      : [];
    const key = JSON.stringify([project.id, project.revision, requests]);
    if (key === this.sourceKey) return;
    this.sourceKey = key;
    this.sourceController?.abort();
    this.sourceErrors = {};
    this.sourceResults = {};
    this.sourceLoading = requests.length > 0;
    if (!requests.length) return;
    const controller = new AbortController();
    this.sourceController = controller;
    void Promise.allSettled(
      requests.map((request) =>
        requestHostSource(this, request, this.sourceHandler, controller.signal),
      ),
    ).then((settled) => {
      if (controller.signal.aborted) return;
      settled.forEach((outcome, index) => {
        const request = requests[index];
        if (outcome.status === "fulfilled")
          this.sourceResults[request.fieldId] = outcome.value;
        else
          this.sourceErrors[request.fieldId] =
            outcome.reason instanceof Error
              ? outcome.reason.message
              : `${request.label}: the source could not be loaded.`;
      });
      this.sourceLoading = false;
      this.event("source-inputs", {
        loaded: Object.keys(this.sourceResults),
        errors: { ...this.sourceErrors },
      });
      this.render();
    });
  }
  private loadedData?: ReturnType<typeof applyFormData>;
  private standaloneForm = false;
  set form(value: FormConfiguration) {
    this.data = {};
    this.project = new FormConfigurationSession(value).editorProject;
    this.standaloneForm = true;
  }
  get form(): FormConfiguration | undefined {
    return this.definition ? formConfiguration(this.definition) : undefined;
  }
  set dataBindings(value: FormDataBinding[]) {
    const bindings = formDataBindingsSchema.parse(value);
    if (JSON.stringify(bindings) === JSON.stringify(this.bindings)) return;
    this.bindings = bindings;
    this.dataParameters = {};
    this.invalidateData();
    this.data = {};
    if (this.isConnected && this.definition)
      void this.refreshData().catch(() => {});
  }
  get dataBindings() {
    return structuredClone(this.bindings);
  }
  set dataProvider(value: FormDataProvider | undefined) {
    if (value !== undefined && typeof value !== "function")
      throw Error("Data provider must be a function");
    if (value === this.provider) return;
    this.provider = value;
    this.invalidateData();
    this.data = {};
    if (this.isConnected && this.definition)
      void this.refreshData().catch(() => {});
  }
  get dataProvider() {
    return this.provider;
  }
  private invalidateData() {
    this.dataController?.abort();
    this.dataEpoch++;
    if (this.bindings.length || this.loadedData) this.hostContext = {};
    this.loadedData = undefined;
    this.dataLoading = false;
    this.dataError = "";
    this.formRevision++;
    this.render();
  }
  async refreshData(
    parameters: Record<string, Record<string, unknown>> = this.dataParameters,
  ) {
    this.invalidateData();
    if (!this.bindings.length || !this.definition || !this.isConnected) return;
    const controller = new AbortController();
    this.dataController = controller;
    const epoch = this.dataEpoch,
      definition = this.definition;
    this.dataLoading = true;
    this.render();
    this.event("data-status", { loading: true });
    try {
      this.dataParameters = structuredClone(parameters);
      const requests = formDataRequests(this.bindings, this.dataParameters);
      const client = new ProofClient(
        this.getAttribute("api-url") || "",
        this.requestHeaders,
      );
      const provider =
        this.provider ||
        ((query, signal) => client.queryIntegrationData(query, signal));
      const responses = await Promise.all(
        requests.map((query) => provider(query, controller.signal)),
      );
      if (
        controller.signal.aborted ||
        epoch !== this.dataEpoch ||
        !this.isConnected
      )
        return;
      this.loadedData = applyFormData(definition, this.bindings, responses);
      this.hostContext = this.loadedData.context;
      this.dataLoading = false;
      this.formRevision++;
      this.render();
      if (this.standaloneForm || !this.hasAttribute("show-proof"))
        this.event("ready", { form: true });
      this.event("data-status", {
        loading: false,
        ready: true,
        sources: requests.map((request) => ({
          sourceId: request.sourceId,
          recordId: request.recordId,
          fields: request.fields,
        })),
      });
    } catch (error) {
      if (controller.signal.aborted || epoch !== this.dataEpoch) return;
      this.dataLoading = false;
      this.dataError =
        "External form data could not be loaded. Retry or contact your host.";
      this.formRevision++;
      this.render();
      this.event("error", { scope: "data", message: this.dataError });
      throw new Error(this.dataError);
    }
  }
  protected configurationChanged() {
    this.formRevision++;
    this.render();
  }
  private parameterValues: SourceParameters = {};
  set sourceParameters(value: SourceParameters) {
    if (this.bindings.length) this.invalidateData();
    this.parameterValues =
      parseContext({ sourceParameters: value }).sourceParameters || {};
    this.hostContext = {};
    this.formRevision++;
    this.render();
  }
  get sourceParameters(): SourceParameters {
    return structuredClone(this.parameterValues);
  }
  private damService?: DamFormServices;
  private transportDam?: DamFormServices;
  private damTransportKey?: string;
  set dam(value: DamFormServices | undefined) {
    if (
      value &&
      (typeof value.browse !== "function" || typeof value.select !== "function")
    )
      throw new Error(
        "Image library services require browse and select callbacks",
      );
    this.damService = value;
    this.formRevision++;
    this.render();
  }
  get dam() {
    return this.damService;
  }
  private hostFontLoader?: FontLoader;
  set loadFont(value: FontLoader | undefined) {
    if (value !== undefined && typeof value !== "function")
      throw new Error("Font loader must be a function");
    this.hostFontLoader = value;
    this.formRevision++;
    this.render();
  }
  get loadFont() {
    return this.hostFontLoader;
  }
  private requestHeaders: Record<string, string> = {};
  private controller?: AbortController;
  private generation = 0;
  private resourceEpoch = 0;
  private remote = false;
  private loading = false;
  private loadError?: string;
  private transportLoadAsset?: AssetLoader;
  private transportTransform?: FormImageServices["transform"];
  private transportUpload?: FormImageServices["upload"];
  set headers(value: Record<string, string>) {
    const next = requestHeaders(value);
    if (JSON.stringify(next) === JSON.stringify(this.requestHeaders)) return;
    this.requestHeaders = next;
    this.invalidateData();
    this.data = {};
    this.resourceEpoch++;
    this.generation++;
    this.controller?.abort();
    this.formRevision++;
    if (this.hasAttribute("project-id")) {
      this.definition = undefined;
      this.data = {};
      this.hostContext = {};
      this.parameterValues = {};
      this.remote = true;
      if (this.isConnected) void this.load();
    } else {
      this.render();
      if (this.isConnected) void this.refreshData().catch(() => {});
    }
  }
  get headers() {
    return { ...this.requestHeaders };
  }
  private readonly proofStatus = (status: {
    ready: boolean;
    error?: string;
  }) => {
    const revision = this.formRevision;
    this.event("status", {
      ...status,
      scope: "proof",
      projectId: this.definition?.id,
    });
    if (revision !== this.formRevision) return;
    if (status.error)
      this.event("error", { message: status.error, scope: "proof" });
    else if (status.ready)
      this.event("ready", { projectId: this.definition?.id });
  };
  private fontBase?: string;
  private fontLoader?: (
    face: { id: string; name: string },
    signal?: AbortSignal,
  ) => Promise<Uint8Array>;
  private root?: Root;
  private definition?: Project;
  private data: Values = {};
  private hostContext: Context = {};
  private mapService?: MapFormServices;
  private formRevision = 0;
  private imageAdapters: FormImageServices = {};
  private transportRemoveBackground?: BackgroundRemovalService;
  private transportAssetUrl?: (id: string) => string;
  set images(value: FormImageServices | undefined) {
    if (
      value &&
      ((value.upload !== undefined && typeof value.upload !== "function") ||
        (value.transform !== undefined &&
          typeof value.transform !== "function") ||
        (value.loadAsset !== undefined &&
          typeof value.loadAsset !== "function") ||
        (value.removeBackground !== undefined &&
          typeof value.removeBackground !== "function") ||
        (value.assets !== undefined && !Array.isArray(value.assets)))
    )
      throw new Error("Image services require callbacks and an asset list");
    this.imageAdapters = {
      ...value,
      assets: value?.assets ? structuredClone(value.assets) : undefined,
    };
    this.formRevision++;
    this.render();
  }
  get images(): FormImageServices {
    return {
      ...this.imageAdapters,
      assets: this.imageAdapters.assets
        ? structuredClone(this.imageAdapters.assets)
        : undefined,
    };
  }
  private assetResolver?: (id: string) => string;
  set assetUrl(value: ((id: string) => string) | undefined) {
    if (value !== undefined && typeof value !== "function")
      throw new Error("Asset URL resolver must be a function");
    this.assetResolver = value;
    this.formRevision++;
    this.render();
  }
  get assetUrl() {
    return this.assetResolver;
  }
  set maps(value: MapFormServices | undefined) {
    this.formRevision++;
    this.mapService = value;
    this.render();
  }
  get maps() {
    return this.mapService;
  }
  private _partId?: string;
  static observedAttributes = [
    "project-id",
    "api-url",
    "part-id",
    "show-proof",
    "presentation",
    "open",
    "width",
    "height",
    "max-width",
    "max-height",
    "form-title",
    "trigger-label",
  ];
  showModal = () => {
    this.setAttribute("open", "");
  };
  close = () => {
    this.removeAttribute("open");
  };
  connectedCallback() {
    this.connectIntegration();
    if (!this.shadowRoot) {
      const shadow = this.attachShadow({ mode: "open" });
      const style = document.createElement("style");
      style.textContent = componentCss + formControlsCss + formPresentationCss;
      shadow.append(style);
      const div = document.createElement("div");
      shadow.append(div);
      this.root = createRoot(div);
    }
    if (!this.root && this.shadowRoot) {
      const mount = this.shadowRoot.querySelector("div");
      if (mount) this.root = createRoot(mount);
    }
    this._partId = this.getAttribute("part-id") || undefined;
    if (this.remote) void this.load();
    else if (this.definition) {
      this.render();
      void this.refreshData().catch(() => {});
    } else void this.load();
  }
  disconnectedCallback() {
    this.disconnectIntegration();
    this.invalidateData();
    this.generation++;
    this.controller?.abort();
    this.formRevision++;
    this.root?.unmount();
    this.root = undefined;
  }
  attributeChangedCallback(
    name: string,
    previous: string | null,
    next: string | null,
  ) {
    if (previous === next) return;
    if (["project-id", "api-url", "part-id"].includes(name))
      this.invalidateData();
    if (name === "project-id" || name === "api-url") this.resourceEpoch++;
    if (name === "part-id" && this.definition) {
      this.data = rebindPartValues(
        this.definition,
        this.data,
        next || undefined,
      );
    }
    this.formRevision++;
    if (this.isConnected) {
      this._partId = this.getAttribute("part-id") || undefined;
      if (name === "project-id" || name === "api-url") void this.load();
      else {
        this.render();
        if (name === "part-id") void this.refreshData().catch(() => {});
      }
    }
  }
  set project(value: Project) {
    this.standaloneForm = false;
    this.invalidateData();
    if (this.definition?.id !== value.id) this.data = {};
    if (this.definition && this.definition.id !== value.id) {
      this.parameterValues = {};
      const { sourceParameters, ...context } = this.hostContext;
      this.hostContext = context;
    }
    this.generation++;
    this.controller?.abort();
    this.remote = false;
    this.loading = false;
    this.loadError = undefined;
    this.definition = parseProject(value);
    this.formRevision++;
    this.render();
    if (this.isConnected) void this.refreshData().catch(() => {});
  }
  get project(): Project {
    return this.definition!;
  }
  set values(value: Values) {
    this.data = structuredClone(value);
    this.formRevision++;
    this.render();
  }
  get values() {
    return structuredClone(this.data);
  }
  set context(value: Context) {
    this.dataController?.abort();
    this.dataEpoch++;
    this.hostContext = parseContext(value);
    if (this.hostContext.sourceParameters)
      this.parameterValues = structuredClone(this.hostContext.sourceParameters);
    this.formRevision++;
    this.render();
  }
  get context(): Context {
    return structuredClone(this.hostContext);
  }
  validate() {
    if (!this.definition) throw new Error("Project is not loaded");
    if (this.bindings.length && !this.loadedData)
      throw new Error("External form data is not ready");
    return validateSubmission(
      this.loadedData?.project || this.definition,
      this.data,
      this._partId,
      this.hostContext,
    );
  }
  private event(name: string, detail: unknown) {
    this.dispatchEvent(
      new CustomEvent(`proof:${name}`, {
        detail,
        bubbles: true,
        composed: true,
      }),
    );
  }
  reload() {
    return this.load();
  }
  private async load() {
    this.invalidateData();
    const generation = ++this.generation;
    this.controller?.abort();
    const id = this.getAttribute("project-id");
    if (!id) {
      if (this.remote) {
        this.definition = undefined;
        this.data = {};
        this.hostContext = {};
      }
      this.remote = false;
      this.loading = false;
      this.loadError = undefined;
      this.render();
      return;
    }
    this.remote = true;
    this.definition = undefined;
    this.loading = true;
    this.loadError = undefined;
    this.data = {};
    this.hostContext = {};
    this.parameterValues = {};
    this.formRevision++;
    const controller = new AbortController();
    this.controller = controller;
    this.render();
    try {
      const definition = await new ProofClient(
        this.getAttribute("api-url") || "",
        this.requestHeaders,
      ).request<Project>(`/projects/${encodeURIComponent(id)}`, {
        signal: controller.signal,
        redirect: "error",
        credentials: requestCredentials(this.requestHeaders),
      });
      if (generation !== this.generation || !this.isConnected) return;
      this.definition = parseProject(definition);
      if (this.definition.id !== id) throw new Error();
      this.loading = false;
      this.render();
      await this.refreshData().catch(() => {});
      if (
        (!this.bindings.length || this.loadedData) &&
        !this.hasAttribute("show-proof")
      )
        this.event("ready", { projectId: id });
    } catch (e) {
      if (controller.signal.aborted || generation !== this.generation) return;
      this.definition = undefined;
      this.loading = false;
      this.loadError =
        e instanceof ProofApiError && [401, 403].includes(e.status)
          ? "Project access denied."
          : "Project could not be loaded.";
      this.render();
      this.event("error", { message: this.loadError });
    }
  }
  private render() {
    integrationDesignMode(this);
    if (!this.root) return;
    this.applyIntegrationTheme();
    if (!this.definition) {
      this.root.render(
        React.createElement(
          "p",
          { role: this.loadError ? "alert" : "status" },
          this.loadError ||
            (this.loading ? "Loading document…" : "No document supplied."),
        ),
      );
      return;
    }
    const baseProject = this.loadedData?.project || this.definition;
    this.loadSourceInputs(baseProject);
    const hosted = applyHostSources(baseProject, this.sourceResults);
    const displayProject = hosted.project;
    const formRevision = this.formRevision;
    const base = this.getAttribute("api-url") || "";
    const transportKey = JSON.stringify([base, this.requestHeaders]);
    if (this.fontBase !== transportKey) {
      this.fontBase = transportKey;
      const client = new ProofClient(base, { ...this.requestHeaders });
      this.transportRemoveBackground = createBackgroundRemover(client.baseUrl, {
        headers: { ...this.requestHeaders },
        credentials: requestCredentials(this.requestHeaders),
      });
      const headers = { ...this.requestHeaders };
      this.transportLoadAsset = (id, signal) => client.loadAsset(id, signal);
      this.transportTransform = (id, adjustments, signal) =>
        client.transformAsset(id, adjustments, signal);
      this.transportUpload = (file, _field, signal) =>
        client.uploadAsset(file, file.name, signal, this.definition?.id);
      this.transportAssetUrl = (id) =>
        `${client.baseUrl}/api/assets/${encodeURIComponent(id)}`;
      this.fontLoader = async (face, signal) => {
        const response = await fetch(client.fontUrl(face.id), {
          signal,
          headers,
          credentials: requestCredentials(headers),
          redirect: "error",
        });
        if (!response.ok) throw new Error(`Font unavailable: ${face.name}`);
        return new Uint8Array(await response.arrayBuffer());
      };
    }
    const authenticated =
      Object.keys(this.requestHeaders).length > 0 && !this.assetResolver;
    const damKey = JSON.stringify([
      transportKey,
      this.definition,
      this._partId,
    ]);
    if (damKey !== this.damTransportKey) {
      this.damTransportKey = damKey;
      this.transportDam = this.hasAttribute("api-url")
        ? damFormServices(
            new ProofClient(base, { ...this.requestHeaders }),
            this.definition,
            this._partId,
          )
        : undefined;
    }
    const loadAsset =
      this.imageAdapters.loadAsset ||
      (authenticated ? this.transportLoadAsset : undefined);
    this.root.render(
      React.createElement(
        FormPresentation,
        {
          modal: this.getAttribute("presentation") === "modal",
          open: this.hasAttribute("open"),
          title: this.getAttribute("form-title") || "Customize document",
          triggerLabel: this.getAttribute("trigger-label") || "Open form",
          width: formDimension(
            this.getAttribute("width"),
            this.getAttribute("presentation") === "modal" ? "720px" : "100%",
          ),
          height: formDimension(this.getAttribute("height"), "auto"),
          maxWidth: formDimension(this.getAttribute("max-width"), "100%"),
          maxHeight: formDimension(this.getAttribute("max-height"), "auto"),
          onOpen: this.showModal,
          onClose: this.close,
        },
        this.dataLoading
          ? React.createElement(
              "p",
              { role: "status" },
              "Loading external form data�",
            )
          : null,
        this.sourceLoading
          ? React.createElement(
              "p",
              { role: "status", className: "source-input-status" },
              "Loading source data from the host…",
            )
          : null,
        Object.keys(this.sourceErrors).length
          ? React.createElement(
              "div",
              { role: "alert", className: "source-input-errors" },
              React.createElement(
                "ul",
                null,
                ...Object.entries(this.sourceErrors).map(([id, message]) =>
                  React.createElement("li", { key: id }, message),
                ),
              ),
              React.createElement(
                "button",
                { type: "button", onClick: () => this.refreshSourceInputs() },
                "Retry source data",
              ),
            )
          : null,
        this.dataError
          ? React.createElement(
              "div",
              { role: "alert" },
              this.dataError,
              React.createElement(
                "button",
                { onClick: () => void this.refreshData().catch(() => {}) },
                "Retry external data",
              ),
            )
          : null,
        React.createElement(
          "fieldset",
          {
            className: "integration-controls",
            disabled:
              !this.integration.permissions.edit ||
              this.dataLoading ||
              this.sourceLoading ||
              (!!this.bindings.length && !this.loadedData),
            "aria-label": "Document customization",
          },
          React.createElement(FormGenerator, {
            removeBackground:
              this.imageAdapters.removeBackground ||
              this.transportRemoveBackground,
            transformImage:
              this.imageAdapters.transform ||
              (authenticated ? this.transportTransform : undefined),
            sourceParameters: this.sourceParameters,
            onSourceParametersChange: (
              parameters: SourceParameters,
              forceRefresh: boolean,
            ) => {
              if (
                formRevision !== this.formRevision ||
                !this.integration.permissions.edit ||
                this.dataLoading ||
                (!!this.bindings.length && !this.loadedData)
              )
                return;
              this.sourceParameters = parameters;
              this.event("source-parameters", {
                sourceParameters: this.sourceParameters,
                forceRefresh,
              });
            },
            key: this.resourceEpoch,
            upload:
              this.imageAdapters.upload ||
              (this.hasAttribute("api-url") ? this.transportUpload : undefined),
            loadAsset,
            assets: this.imageAdapters.assets,
            fieldAssets: hosted.fieldAssets,
            maps: this.mapService,
            dam: this.damService || this.transportDam,
            project: displayProject,
            values: this.data,
            partId: this._partId,
            context: this.hostContext,
            compact: false,
            showValidation: true,
            assetUrl: this.assetResolver || this.transportAssetUrl,
            onChange: (values: Values) => {
              if (
                formRevision !== this.formRevision ||
                !this.integration.permissions.edit ||
                this.dataLoading ||
                (!!this.bindings.length && !this.loadedData)
              )
                return;
              this.formRevision++;
              this.data = values;
              this.render();
              this.event("change", {
                values: this.values,
                validation: this.validate().errors,
              });
            },
          }),
        ),
        this.hasAttribute("show-proof") &&
          !this.standaloneForm &&
          (!this.bindings.length || !!this.loadedData) &&
          this.integration.permissions.proof
          ? React.createElement(ProofCanvas, {
              key: this.resourceEpoch,
              transformImage:
                this.imageAdapters.transform ||
                (authenticated ? this.transportTransform : undefined),
              loadAsset,
              project: displayProject,
              values: this.data,
              partId: this._partId,
              context: this.hostContext,
              zoom: 0.65,
              assetUrl: this.assetResolver || this.transportAssetUrl,
              loadFont: this.hostFontLoader || this.fontLoader,
              onStatus: (status: { ready: boolean; error?: string }) => {
                if (formRevision === this.formRevision)
                  this.proofStatus(status);
              },
            })
          : null,
      ),
    );
  }
}
export function registerProofForm() {
  if (
    typeof customElements !== "undefined" &&
    !customElements.get("proof-form")
  )
    customElements.define("proof-form", ProofFormElement);
}
export class ProofAuthoringElement extends IntegrationElement {
  protected configurationChanged() {
    this.render();
  }
  private modeAllowed() {
    return this.integration.allowedModes.includes(
      (this.getAttribute("mode") || "designer") as AuthoringMode,
    );
  }
  private canEdit() {
    return this.integration.permissions.edit && this.modeAllowed();
  }
  private remote = false;
  private loading = false;
  private loadError?: string;
  private root?: Root;
  private session?: AuthoringSession;
  private adapters: AuthoringServices = {};
  private transport?: AuthoringServices;
  private requestHeaders: Record<string, string> = {};
  private controller?: AbortController;
  private generation = 0;
  static observedAttributes = ["project-id", "api-url", "mode"];
  connectedCallback() {
    this.connectIntegration();
    if (!this.shadowRoot) {
      const shadow = this.attachShadow({ mode: "open" });
      const style = document.createElement("style");
      style.textContent = authoringStyles;
      shadow.append(style);
      const mount = document.createElement("div");
      mount.dataset.authoringMount = "";
      shadow.append(mount);
    }
    if (!this.root)
      this.root = createRoot(
        this.shadowRoot!.querySelector<HTMLDivElement>(
          "[data-authoring-mount]",
        )!,
      );
    if (this.remote) void this.load();
    else if (this.session) this.render();
    else void this.load();
  }
  disconnectedCallback() {
    this.disconnectIntegration();
    this.generation++;
    this.controller?.abort();
    this.root?.unmount();
    this.root = undefined;
  }
  attributeChangedCallback(
    name: string,
    oldValue: string | null,
    value: string | null,
  ) {
    if (oldValue === value) return;
    if (name === "api-url") this.transport = undefined;
    if (!this.isConnected) return;
    if (name === "mode") this.render();
    else if (this.hasAttribute("project-id") || this.remote) void this.load();
    else {
      this.generation++;
      this.controller?.abort();
      this.render();
    }
  }
  set project(value: Project) {
    this.remote = false;
    this.loading = false;
    this.loadError = undefined;
    this.generation++;
    this.controller?.abort();
    try {
      this.session = new AuthoringSession(value);
      this.render();
      this.event("ready", {
        projectId: this.session.project.id,
        scope: "authoring",
      });
    } catch (error) {
      this.event("error", { message: (error as Error).message });
      throw error;
    }
  }
  get project(): Project {
    if (!this.session) throw new Error("Project is not loaded");
    return this.session.project;
  }
  set services(value: AuthoringServices) {
    this.adapters = { ...value };
    this.render();
  }
  get services() {
    return { ...this.adapters };
  }
  set headers(value: Record<string, string>) {
    const next = requestHeaders(value);
    if (JSON.stringify(next) === JSON.stringify(this.requestHeaders)) return;
    this.requestHeaders = next;
    this.transport = undefined;
    this.generation++;
    this.controller?.abort();
    if (this.hasAttribute("project-id")) {
      this.session = undefined;
      this.remote = true;
      if (this.isConnected) void this.load();
    } else this.render();
  }
  get headers() {
    return { ...this.requestHeaders };
  }
  get canUndo() {
    return this.canEdit() && (this.session?.canUndo || false);
  }
  get canRedo() {
    return this.canEdit() && (this.session?.canRedo || false);
  }
  undo() {
    if (!this.session || !this.canEdit()) return;
    this.session.undo();
    this.changed("undo");
  }
  redo() {
    if (!this.session || !this.canEdit()) return;
    this.session.redo();
    this.changed("redo");
  }
  private event(name: string, detail: unknown) {
    this.dispatchEvent(
      new CustomEvent(`proof:${name}`, {
        detail,
        bubbles: true,
        composed: true,
      }),
    );
  }
  private changed(reason: string) {
    this.render();
    this.event("change", {
      project: this.project,
      reason,
      canUndo: this.canUndo,
      canRedo: this.canRedo,
    });
  }
  reload() {
    return this.load();
  }
  private async load() {
    const generation = ++this.generation;
    this.controller?.abort();
    const id = this.getAttribute("project-id");
    if (!id) {
      if (this.remote) this.session = undefined;
      this.remote = false;
      this.loading = false;
      this.loadError = undefined;
      this.render();
      return;
    }
    this.remote = true;
    this.session = undefined;
    this.loading = true;
    this.loadError = undefined;
    const controller = new AbortController();
    this.controller = controller;
    this.render();
    try {
      const project = await new ProofClient(
        this.getAttribute("api-url") || "",
        this.requestHeaders,
      ).request<Project>(`/projects/${encodeURIComponent(id)}`, {
        signal: controller.signal,
        redirect: "error",
        credentials: requestCredentials(this.requestHeaders),
      });
      if (generation !== this.generation || !this.isConnected) return;
      if (project.id !== id) throw new Error();
      this.session = new AuthoringSession(project);
      this.loading = false;
      this.render();
      this.event("ready", { projectId: project.id, scope: "authoring" });
    } catch (error) {
      if (!controller.signal.aborted && generation === this.generation) {
        this.loading = false;
        this.loadError =
          error instanceof ProofApiError && [401, 403].includes(error.status)
            ? "Project access denied."
            : "Project could not be loaded.";
        this.render();
        this.event("error", { message: this.loadError });
      }
    }
  }
  private getTransport(): AuthoringServices {
    if (!this.hasAttribute("api-url")) return {};
    if (!this.transport) {
      const base = this.getAttribute("api-url") || "",
        client = new ProofClient(base, this.requestHeaders),
        headers = this.requestHeaders;
      this.transport = {
        listFieldPresets: (query) => client.listFieldPresets(query),
        saveFieldPreset: (input) => client.saveFieldPreset(input),
        listFormProjects: async (query, signal) => {
          const page = await client.request<{
            items: { id: string; name: string }[];
          }>(
            `/projects?projection=summary&limit=100&search=${encodeURIComponent(query)}`,
            { signal },
          );
          return page.items;
        },
        loadFormProject: async (id, signal) => {
          const project = await client.getProject(id);
          signal.throwIfAborted();
          return project;
        },
        listResources: () => client.listResources(),
        saveResource: (resource) => client.saveResource(resource),
        dam: (project, partId) => damFormServices(client, project, partId),
        listDamProviders: () => client.listDamProviders(),
        loadAsset: Object.keys(headers).length
          ? (id, signal) => client.loadAsset(id, signal)
          : undefined,
        upload: (file, _field, signal) =>
          client.uploadAsset(file, file.name, signal, this.session?.project.id),
        importBase: async (file, signal) =>
          (await client.importDocument(file, file.name, signal)).project,
        importPdfArtwork: (file, page, signal) =>
          client.importPdfArtwork(file, file.name, page, signal),
        listFonts: async () =>
          (await client.listFonts())
            .filter((r) => r.status === "active")
            .map((r) => r.face),
        loadFont: async (face, signal) => {
          const response = await fetch(client.fontUrl(face.id), {
            signal,
            headers,
            redirect: "error",
            credentials: requestCredentials(headers),
          });
          if (!response.ok) throw new Error(`Font unavailable: ${face.name}`);
          return new Uint8Array(await response.arrayBuffer());
        },
        assetUrl: (id) =>
          `${client.baseUrl}/api/assets/${encodeURIComponent(id)}`,
        transformImage: (id, adjustments, signal) =>
          client.transformAsset(id, adjustments, signal),
        removeBackground: createBackgroundRemover(client.baseUrl, {
          headers: { ...headers },
          credentials: requestCredentials(headers),
        }),
        listAssets: (signal) =>
          client.listAssets(signal, this.session?.project.id),
      };
    }
    return this.transport;
  }
  private render() {
    integrationDesignMode(this);
    if (!this.root) return;
    this.applyIntegrationTheme();
    if (!this.session) {
      this.root.render(
        React.createElement(
          "p",
          { role: this.loadError ? "alert" : "status" },
          this.loadError ||
            (this.loading ? "Loading document…" : "No document supplied."),
        ),
      );
      return;
    }
    const mode = this.getAttribute("mode") || "designer";
    const generation = this.generation;
    if (
      !authoringModes.includes(mode as AuthoringMode) ||
      !this.modeAllowed()
    ) {
      const message = "This authoring flow is not available.";
      this.root.render(React.createElement("p", { role: "alert" }, message));
      this.event("error", { message });
      return;
    }
    const common = {
      key: `${this.project.id}:${this.generation}`,
      project: this.project,
      services: {
        ...this.getTransport(),
        ...this.adapters,
        editorPresentation: this.integration.editor,
        loadAsset:
          this.adapters.loadAsset ||
          (!this.adapters.assetUrl ? this.getTransport().loadAsset : undefined),
        onProofStatus: (status: { ready: boolean; error?: string }) => {
          this.adapters.onProofStatus?.(status);
          if (status.error)
            this.event("error", { message: status.error, scope: "proof" });
        },
      },
      notify: (message: string) => this.event("notice", { message }),
      onChange: (project: Project) => {
        if (
          !this.canEdit() ||
          generation !== this.generation ||
          (this.getAttribute("mode") !== mode &&
            !(mode === "designer" && !this.hasAttribute("mode")))
        )
          return;
        try {
          this.session!.update(project);
          this.changed("edit");
        } catch (error) {
          this.event("error", { message: (error as Error).message });
        }
      },
    };
    const tryItOut = common.services.tryItOut;
    common.services.tryItOut =
      tryItOut && this.integration.permissions.proof
        ? (project, signal) => {
            if (
              !this.integration.permissions.proof ||
              generation !== this.generation ||
              (this.getAttribute("mode") || "designer") !== "designer"
            )
              throw new Error(
                "Proof preview is not available for this integration.",
              );
            return tryItOut(project, signal);
          }
        : undefined;
    // Recheck at invocation time, including callbacks retained by async dialogs.
    for (const key of [
      "saveFieldPreset",
      "saveResource",
      "saveProfileDataset",
      "upload",
      "importBase",
      "importPdfArtwork",
      "transformImage",
      "removeBackground",
    ] as const) {
      const service = common.services[key];
      if (service)
        Object.assign(common.services, {
          [key]: (...args: unknown[]) => {
            if (
              !this.canEdit() ||
              generation !== this.generation ||
              (this.getAttribute("mode") || "designer") !== mode
            )
              return Promise.reject(
                new Error("Editing is disabled for this integration."),
              );
            return (service as (...input: unknown[]) => unknown)(...args);
          },
        });
    }
    const canEdit = this.canEdit();
    const checkServiceWrite = () => {
      if (
        !this.canEdit() ||
        generation !== this.generation ||
        (this.getAttribute("mode") || "designer") !== mode
      )
        throw new Error("Editing is disabled for this integration.");
    };
    if (common.services.maps) {
      const maps = common.services.maps;
      common.services.maps = {
        ...maps,
        create: async (...args) => {
          checkServiceWrite();
          return maps.create(...args);
        },
      };
    }
    if (common.services.dam) {
      const dam = common.services.dam;
      common.services.dam = (...args) => {
        const service = dam(...args);
        return {
          ...service,
          select: async (...selection) => {
            checkServiceWrite();
            return service.select(...selection);
          },
        };
      };
    }
    this.root.render(
      !canEdit && mode !== "summary"
        ? React.createElement(
            React.Fragment,
            null,
            React.createElement(
              "p",
              { role: "status", className: "integration-restriction" },
              this.integration.allowedModes.includes("summary")
                ? "Editing is disabled for this integration. Showing the project summary."
                : "Editing is disabled for this integration.",
            ),
            this.integration.allowedModes.includes("summary")
              ? React.createElement(ProjectSummary, {
                  project: this.project,
                  canEdit: false,
                  canNavigate: (destination: string) =>
                    this.canNavigate(destination),
                  canExport: this.integration.permissions.export,
                  canProof: this.integration.permissions.proof,
                  onGo: (destination: string) => this.navigate(destination),
                  onExport: () => this.exportProject(),
                  onDetails: () => {},
                })
              : null,
          )
        : ["validation-presets", "formatting-presets"].includes(mode)
          ? React.createElement(FieldPresetLibrary, {
              services: common.services,
              project: this.project,
              kind: mode === "validation-presets" ? "validation" : "format",
            })
          : mode === "summary"
            ? React.createElement(ProjectSummary, {
                project: this.project,
                canEdit,
                canNavigate: (destination: string) =>
                  this.canNavigate(destination),
                canExport: this.integration.permissions.export,
                canProof: this.integration.permissions.proof,
                onGo: (destination: string) => this.navigate(destination),
                onExport: () => this.exportProject(),
                onDetails: () => {
                  if (this.canEdit())
                    this.event("details", { project: this.project });
                },
              })
            : mode === "configuration" || mode === "reusable-forms"
              ? React.createElement(Configuration, {
                  ...common,
                  initialView: mode === "reusable-forms" ? "layout" : "fields",
                })
              : mode === "outputs"
                ? React.createElement(Outputs, common)
                : mode === "global-profiles"
                  ? React.createElement(GlobalProfiles, common)
                  : React.createElement(Designer, {
                      ...common,
                      onUndo: () => this.undo(),
                      onRedo: () => this.redo(),
                      canUndo: this.canUndo,
                      canRedo: this.canRedo,
                    }),
    );
  }
  private canNavigate(destination: string) {
    if (destination === "proof") return this.integration.permissions.proof;
    if (
      authoringModes.includes(destination as AuthoringMode) &&
      (!this.canEdit() ||
        !this.integration.allowedModes.includes(destination as AuthoringMode))
    )
      return false;
    return true;
  }
  private navigate(destination: string) {
    if (!this.canNavigate(destination)) return;
    this.event("navigate", { destination });
  }
  private exportProject() {
    if (this.integration.permissions.export && this.modeAllowed())
      this.event("export", { project: this.project });
  }
}
export function registerProofAuthoring() {
  if (
    typeof customElements !== "undefined" &&
    !customElements.get("proof-authoring")
  )
    customElements.define("proof-authoring", ProofAuthoringElement);
}

/** A standalone configuration form for plain JavaScript hosts, with no API dependency. */
export class ProofConfigurationElement extends ElementBase {
  private root?: Root;
  private content: unknown = null;
  private settings: Omit<ConfigurationEditorProps, "value" | "onSave"> & {
    onSave?: ConfigurationEditorProps["onSave"];
  } = {};
  private generation = 0;
  connectedCallback() {
    if (!this.shadowRoot) {
      const shadow = this.attachShadow({ mode: "open" });
      const style = document.createElement("style");
      style.textContent = authoringStyles;
      const mount = document.createElement("div");
      mount.dataset.configurationMount = "";
      shadow.append(style, mount);
    }
    this.root ||= createRoot(
      this.shadowRoot!.querySelector<HTMLDivElement>(
        "[data-configuration-mount]",
      )!,
    );
    this.render();
  }
  disconnectedCallback() {
    this.generation++;
    this.root?.unmount();
    this.root = undefined;
  }
  set value(value: unknown) {
    this.content = parseConfiguration(JSON.stringify(value));
    this.generation++;
    this.render();
  }
  get value(): unknown {
    return parseConfiguration(JSON.stringify(this.content));
  }
  set options(options: typeof this.settings) {
    this.settings = { ...options };
    this.generation++;
    this.render();
  }
  get options() {
    return { ...this.settings };
  }
  private event(name: string, detail: unknown) {
    this.dispatchEvent(
      new CustomEvent(`proof:${name}`, {
        detail,
        bubbles: true,
        composed: true,
      }),
    );
  }
  private render() {
    integrationDesignMode(this);
    if (!this.root) return;
    const generation = this.generation;
    this.root.render(
      React.createElement(ConfigurationEditor, {
        ...this.settings,
        value: this.value,
        onSave: async (candidate) => {
          const detached = parseConfiguration(JSON.stringify(candidate));
          await this.settings.onSave?.(
            parseConfiguration(JSON.stringify(detached)),
          );
          if (generation !== this.generation || !this.isConnected)
            throw new Error(
              "Configuration changed while applying. Review and apply the current draft again.",
            );
          this.content = detached;
          this.event("configuration", { value: this.value });
        },
      }),
    );
  }
}
export function registerProofConfiguration() {
  if (
    typeof customElements !== "undefined" &&
    !customElements.get("proof-configuration")
  )
    customElements.define("proof-configuration", ProofConfigurationElement);
}

/** Adapt the standard HTTP client without coupling the view to its transport. */
export function projectExportServices(
  client: Pick<ProofClient, "projectPackageReport" | "exportProjectPackage">,
): ProjectExportServices {
  return {
    report: (project, selection, signal) =>
      client.projectPackageReport(project, signal, selection),
    exportPackage: (project, selection, signal) =>
      client.exportProjectPackage(project, signal, selection),
  };
}
export interface ProjectExportElementOptions {
  target?: PackageTarget;
  partId?: string;
  allowedTargets?: PackageTarget[];
  download?: boolean;
}
/** Plain-JavaScript export panel. API access is enabled only by an explicit api-url. */
export class ProofProjectExportElement extends ElementBase {
  static get observedAttributes() {
    return ["api-url"];
  }
  private root?: Root;
  private definition?: Project;
  private adapters?: ProjectExportServices;
  private settings: ProjectExportElementOptions = {};
  private requestHeaders: Record<string, string> = {};
  private generation = 0;
  connectedCallback() {
    if (!this.shadowRoot) {
      const shadow = this.attachShadow({ mode: "open" }),
        style = document.createElement("style"),
        mount = document.createElement("div");
      style.textContent = authoringStyles;
      mount.dataset.projectExportMount = "";
      shadow.append(style, mount);
    }
    this.root ||= createRoot(
      this.shadowRoot!.querySelector<HTMLDivElement>(
        "[data-project-export-mount]",
      )!,
    );
    this.render();
  }
  disconnectedCallback() {
    this.generation++;
    this.root?.unmount();
    this.root = undefined;
  }
  attributeChangedCallback() {
    this.reload();
  }
  set project(value: Project | undefined) {
    this.definition = value ? parseProject(structuredClone(value)) : undefined;
    this.reload();
  }
  get project(): Project | undefined {
    return this.definition && structuredClone(this.definition);
  }
  set services(value: ProjectExportServices | undefined) {
    if (
      value &&
      (typeof value.report !== "function" ||
        typeof value.exportPackage !== "function")
    )
      throw new TypeError("Provide report and exportPackage callbacks");
    this.adapters = value && {
      report: value.report.bind(value),
      exportPackage: value.exportPackage.bind(value),
    };
    this.reload();
  }
  get services() {
    return this.adapters && { ...this.adapters };
  }
  set headers(value: Record<string, string>) {
    this.requestHeaders = { ...value };
    this.reload();
  }
  get headers() {
    return { ...this.requestHeaders };
  }
  set options(value: ProjectExportElementOptions) {
    const formats = ["native", "idml", "composition"];
    if (
      (value.target !== undefined && !formats.includes(value.target)) ||
      (value.partId !== undefined && typeof value.partId !== "string") ||
      (value.download !== undefined && typeof value.download !== "boolean") ||
      (value.allowedTargets !== undefined &&
        (!Array.isArray(value.allowedTargets) ||
          !value.allowedTargets.length ||
          value.allowedTargets.some((target) => !formats.includes(target)) ||
          new Set(value.allowedTargets).size !==
            value.allowedTargets.length)) ||
      (value.target &&
        value.allowedTargets &&
        !value.allowedTargets.includes(value.target))
    )
      throw new TypeError("Choose valid project export options");
    this.settings = structuredClone(value);
    this.reload();
  }
  get options() {
    return structuredClone(this.settings);
  }
  reload() {
    this.generation++;
    this.render();
  }
  private render() {
    integrationDesignMode(this);
    if (!this.root) return;
    const generation = this.generation;
    const services =
      this.adapters ||
      (this.hasAttribute("api-url")
        ? projectExportServices(
            new ProofClient(
              this.getAttribute("api-url") || "",
              this.requestHeaders,
            ),
          )
        : undefined);
    if (!this.definition || !services) {
      this.root.render(
        React.createElement(
          "p",
          { role: "status" },
          !this.definition
            ? "No document supplied."
            : "Provide export services or an explicit api-url.",
        ),
      );
      return;
    }
    this.root.render(
      React.createElement(ProjectExport, {
        key: generation,
        project: this.project!,
        services,
        initialTarget: this.settings.target,
        initialPartId: this.settings.partId,
        allowedTargets: this.settings.allowedTargets,
        onSelectionChange: (selection) => {
          if (generation !== this.generation || !this.isConnected) return;
          this.settings = {
            ...this.settings,
            target: selection.target,
            partId: selection.partId,
          };
          this.dispatchEvent(
            new CustomEvent("proof:selection", {
              detail: { ...selection },
              bubbles: true,
              composed: true,
            }),
          );
        },
        onDownload: (artifact: ProjectExportArtifact, signal: AbortSignal) => {
          const current = () =>
            generation === this.generation &&
            this.isConnected &&
            !signal.aborted;
          if (!current()) return;
          const accepted = this.dispatchEvent(
            new CustomEvent("proof:package", {
              detail: { ...artifact, report: structuredClone(artifact.report) },
              cancelable: true,
              bubbles: true,
              composed: true,
            }),
          );
          if (current() && accepted && this.settings.download !== false)
            downloadProjectPackage(artifact);
        },
      }),
    );
  }
}
export function registerProofProjectExport() {
  if (
    typeof customElements !== "undefined" &&
    !customElements.get("proof-project-export")
  )
    customElements.define("proof-project-export", ProofProjectExportElement);
}

/** Use an explicit client; the panel itself has no HTTP dependency. */
export function documentImportServices(
  client: Pick<ProofClient, "importDocument"> &
    Partial<Pick<ProofClient, "prepareProjectImages" | ArchiveMethods>>,
): DocumentImportServices {
  return {
    ...(client.startProjectArchive &&
    client.projectArchive &&
    client.uploadProjectArchiveChunk &&
    client.importArchiveProject &&
    client.removeProjectArchive
      ? {
          archive: bindProjectArchiveImportServices(
            client as Pick<ProofClient, ArchiveMethods>,
          ),
        }
      : {}),
    ...(client.prepareProjectImages
      ? {
          prepareProject: (project: Project, signal: AbortSignal) =>
            client.prepareProjectImages!(project, signal),
        }
      : {}),
    importDocument: (file, selection, signal) =>
      client.importDocument(file, file.name, signal, selection),
  };
}
type ArchiveMethods =
  | "startProjectArchive"
  | "projectArchive"
  | "uploadProjectArchiveChunk"
  | "importArchiveProject"
  | "removeProjectArchive";
export function bindProjectArchiveImportServices(
  client: Pick<ProofClient, ArchiveMethods>,
): ProjectArchiveImportServices {
  return {
    startUpload: (input, signal) => client.startProjectArchive(input, signal),
    uploadStatus: (id, signal) => client.projectArchive(id, signal),
    uploadChunk: (id, offset, chunk, signal) =>
      client.uploadProjectArchiveChunk(id, offset, chunk, signal),
    importProject: (id, entryId, template, signal) =>
      client.importArchiveProject(id, entryId, template, signal),
    removeUpload: (id, signal) => client.removeProjectArchive(id, signal),
  };
}
export interface DocumentImportElementOptions {
  jsonTenant?: string;
  title?: string;
  downloadReport?: boolean;
}
export class ProofDocumentImportElement extends ElementBase {
  static get observedAttributes() {
    return ["api-url"];
  }
  private root?: Root;
  private adapters?: DocumentImportServices;
  private settings: DocumentImportElementOptions = {};
  private requestHeaders: Record<string, string> = {};
  private importHandler?: DocumentImportProps["onImport"];
  private generation = 0;
  private context = new AbortController();
  connectedCallback() {
    if (this.context.signal.aborted) this.context = new AbortController();
    if (!this.shadowRoot) {
      const shadow = this.attachShadow({ mode: "open" }),
        style = document.createElement("style"),
        mount = document.createElement("div");
      style.textContent = authoringStyles;
      mount.dataset.documentImportMount = "";
      shadow.append(style, mount);
    }
    this.root ||= createRoot(
      this.shadowRoot!.querySelector<HTMLDivElement>(
        "[data-document-import-mount]",
      )!,
    );
    this.render();
  }
  disconnectedCallback() {
    this.context.abort();
    this.generation++;
    this.root?.unmount();
    this.root = undefined;
  }
  attributeChangedCallback() {
    this.reload();
  }
  set services(value: DocumentImportServices | undefined) {
    if (value && typeof value.importDocument !== "function")
      throw new TypeError("Provide an importDocument callback");
    this.adapters = value && {
      importDocument: value.importDocument.bind(value),
      prepareProject: value.prepareProject?.bind(value),
    };
    this.reload();
  }
  get services() {
    return this.adapters && { ...this.adapters };
  }
  set headers(value: Record<string, string>) {
    this.requestHeaders = { ...value };
    this.reload();
  }
  get headers() {
    return { ...this.requestHeaders };
  }
  set options(value: DocumentImportElementOptions) {
    if (
      !value ||
      (value.jsonTenant !== undefined &&
        (typeof value.jsonTenant !== "string" || !value.jsonTenant.trim())) ||
      (value.title !== undefined &&
        (typeof value.title !== "string" || !value.title.trim())) ||
      (value.downloadReport !== undefined &&
        typeof value.downloadReport !== "boolean")
    )
      throw new TypeError("Choose valid document import options");
    this.settings = structuredClone(value);
    this.reload();
  }
  get options() {
    return structuredClone(this.settings);
  }
  set onImport(value: DocumentImportProps["onImport"] | undefined) {
    if (value !== undefined && typeof value !== "function")
      throw new TypeError("Provide an import handler");
    this.importHandler = value;
    this.reload();
  }
  get onImport() {
    return this.importHandler;
  }
  reload() {
    this.context.abort();
    this.context = new AbortController();
    this.generation++;
    this.render();
  }
  private render() {
    integrationDesignMode(this);
    if (!this.root) return;
    const generation = this.generation,
      context = this.context;
    const services =
      this.adapters ||
      (this.hasAttribute("api-url")
        ? documentImportServices(
            new ProofClient(
              this.getAttribute("api-url") || "",
              this.requestHeaders,
            ),
          )
        : undefined);
    if (!services) {
      this.root.render(
        React.createElement(
          "p",
          { role: "status" },
          "Provide import services or an explicit api-url.",
        ),
      );
      return;
    }
    const current = (signal?: AbortSignal) =>
      generation === this.generation &&
      this.isConnected &&
      !context.signal.aborted &&
      !signal?.aborted;
    this.root.render(
      React.createElement(DocumentImport, {
        key: generation,
        services: {
          archive: services.archive
            ? {
                startUpload: (input, signal) =>
                  services.archive!.startUpload(
                    input,
                    AbortSignal.any([signal, context.signal]),
                  ),
                uploadStatus: (id, signal) =>
                  services.archive!.uploadStatus(
                    id,
                    AbortSignal.any([signal, context.signal]),
                  ),
                uploadChunk: (id, offset, chunk, signal) =>
                  services.archive!.uploadChunk(
                    id,
                    offset,
                    chunk,
                    AbortSignal.any([signal, context.signal]),
                  ),
                importProject: (id, entryId, template, signal) =>
                  services.archive!.importProject(
                    id,
                    entryId,
                    template,
                    AbortSignal.any([signal, context.signal]),
                  ),
                removeUpload: (id, signal) =>
                  services.archive!.removeUpload(id, signal),
              }
            : undefined,
          prepareProject: services.prepareProject
            ? async (project, signal) => {
                const combined = AbortSignal.any([signal, context.signal]);
                combined.throwIfAborted();
                const result = await services.prepareProject!(
                  project,
                  combined,
                );
                combined.throwIfAborted();
                return result;
              }
            : undefined,
          importDocument: async (file, selection, signal) => {
            const combined = AbortSignal.any([signal, context.signal]);
            combined.throwIfAborted();
            const result = await services.importDocument(
              file,
              selection,
              combined,
            );
            combined.throwIfAborted();
            return result;
          },
        },
        jsonTenant: this.settings.jsonTenant,
        title: this.settings.title,
        onImport: async (
          project: Project,
          report: ImportReport | undefined,
          signal: AbortSignal,
        ) => {
          const combined = AbortSignal.any([signal, context.signal]);
          if (!current(combined)) return;
          const result = {
            project: structuredClone(project),
            ...(report ? { report: structuredClone(report) } : {}),
          };
          const accept = this.importHandler;
          if (accept)
            await accept(
              structuredClone(project),
              report && structuredClone(report),
              combined,
            );
          if (current(combined))
            this.dispatchEvent(
              new CustomEvent("proof:import", {
                detail: result,
                bubbles: true,
                composed: true,
              }),
            );
        },
        onOpen: () => {
          if (current())
            this.dispatchEvent(
              new CustomEvent("proof:open", { bubbles: true, composed: true }),
            );
        },
        onReportDownload: (report: ImportReport) => {
          if (!current()) return;
          const accepted = this.dispatchEvent(
            new CustomEvent("proof:import-report", {
              detail: structuredClone(report),
              bubbles: true,
              composed: true,
              cancelable: true,
            }),
          );
          if (current() && accepted && this.settings.downloadReport !== false)
            downloadImportReport(report);
        },
      }),
    );
  }
}
export function registerProofDocumentImport() {
  if (
    typeof customElements !== "undefined" &&
    !customElements.get("proof-document-import")
  )
    customElements.define("proof-document-import", ProofDocumentImportElement);
}

/** Explicit API adapter. Independent hosts can provide these callbacks directly. */
export function revisionReviewServices(
  client: Pick<
    ProofClient,
    "projectPackageReport" | "loadAsset" | "transformAsset" | "loadFont"
  >,
): RevisionReviewServices {
  return {
    validateResources: async (project, signal) => {
      await client.projectPackageReport(project, signal);
    },
    loadAsset: (id, signal) => client.loadAsset(id, signal),
    transformImage: (id, adjustments, signal) =>
      client.transformAsset(id, adjustments, signal),
    loadFont: (face, signal) => client.loadFont(face, signal),
  };
}
export type RevisionApplyHandler = (
  project: Project,
  report: RevisionReviewReport,
  signal: AbortSignal,
) => void | Promise<void>;
export interface RevisionReviewElementOptions {
  downloadReport?: boolean;
}
export class ProofRevisionReviewElement extends ElementBase {
  static get observedAttributes() {
    return ["api-url"];
  }
  private root?: Root;
  private currentProject?: Project;
  private originalProject?: Project;
  private incomingProject?: Project;
  private report?: ImportReport;
  private adapters?: RevisionReviewServices;
  private accept?: RevisionApplyHandler;
  private requestHeaders: Record<string, string> = {};
  private settings: RevisionReviewElementOptions = {};
  private generation = 0;
  private scope?: AbortController;
  connectedCallback() {
    if (!this.shadowRoot) {
      const shadow = this.attachShadow({ mode: "open" }),
        style = document.createElement("style"),
        mount = document.createElement("div");
      style.textContent = ":host{display:block;min-width:0}" + authoringStyles;
      mount.dataset.revisionReviewMount = "";
      shadow.append(style, mount);
    }
    this.root ||= createRoot(
      this.shadowRoot!.querySelector<HTMLDivElement>(
        "[data-revision-review-mount]",
      )!,
    );
    this.reload();
  }
  disconnectedCallback() {
    this.scope?.abort();
    this.scope = undefined;
    this.generation++;
    this.root?.unmount();
    this.root = undefined;
  }
  attributeChangedCallback() {
    this.reload();
  }
  set project(value: Project | undefined) {
    const previous = this.currentProject;
    this.currentProject = undefined;
    try {
      this.currentProject = value
        ? parseProject(structuredClone(value))
        : undefined;
    } finally {
      if (
        !this.currentProject ||
        previous?.id !== this.currentProject.id ||
        previous?.tenantId !== this.currentProject.tenantId
      ) {
        this.incomingProject = undefined;
        this.report = undefined;
        if (
          this.originalProject &&
          (this.originalProject.id !== this.currentProject?.id ||
            this.originalProject.tenantId !== this.currentProject?.tenantId)
        )
          this.originalProject = undefined;
      }
      this.reload();
    }
  }
  get project() {
    return this.currentProject && structuredClone(this.currentProject);
  }
  set baseline(value: Project | undefined) {
    this.originalProject = undefined;
    try {
      const project = value && parseProject(structuredClone(value));
      if (
        project &&
        this.currentProject &&
        (project.id !== this.currentProject.id ||
          project.tenantId !== this.currentProject.tenantId)
      )
        throw new TypeError(
          "Revision baseline identity does not match the current project",
        );
      this.originalProject = project;
    } finally {
      this.reload();
    }
  }
  get baseline() {
    return this.originalProject && structuredClone(this.originalProject);
  }
  set incoming(value: Project | undefined) {
    this.incomingProject = undefined;
    this.report = undefined;
    try {
      const project = value ? parseProject(structuredClone(value)) : undefined;
      if (
        project &&
        this.currentProject &&
        project.tenantId !== this.currentProject.tenantId
      )
        throw new TypeError(
          "Revision tenant does not match the current project",
        );
      this.incomingProject = project;
    } finally {
      this.reload();
    }
  }
  get incoming() {
    return this.incomingProject && structuredClone(this.incomingProject);
  }
  set importReport(value: ImportReport | undefined) {
    this.report = undefined;
    try {
      this.report = value && snapshotImportReport(value);
    } finally {
      this.reload();
    }
  }
  get importReport() {
    return this.report && structuredClone(this.report);
  }
  set services(value: RevisionReviewServices | undefined) {
    this.adapters = undefined;
    try {
      this.adapters = value && bindRevisionReviewServices(value);
    } finally {
      this.reload();
    }
  }
  get services() {
    return this.adapters && { ...this.adapters };
  }
  set onApply(value: RevisionApplyHandler | undefined) {
    this.accept = undefined;
    try {
      if (value !== undefined && typeof value !== "function")
        throw new TypeError("Provide an onApply callback");
      this.accept = value;
    } finally {
      this.reload();
    }
  }
  get onApply() {
    return this.accept;
  }
  set headers(value: Record<string, string>) {
    this.requestHeaders = {};
    try {
      this.requestHeaders = requestHeaders(value);
    } finally {
      this.reload();
    }
  }
  get headers() {
    return { ...this.requestHeaders };
  }
  set options(value: RevisionReviewElementOptions) {
    if (
      !value ||
      (value.downloadReport !== undefined &&
        typeof value.downloadReport !== "boolean")
    )
      throw new TypeError("Choose valid revision review options");
    this.settings = { downloadReport: value.downloadReport };
    this.reload();
  }
  get options() {
    return { ...this.settings };
  }
  reload() {
    this.scope?.abort();
    this.scope = new AbortController();
    this.generation++;
    this.render();
  }
  private render() {
    integrationDesignMode(this);
    if (!this.root) return;
    const generation = this.generation,
      scope = this.scope!;
    const services =
      this.adapters ||
      (this.hasAttribute("api-url")
        ? revisionReviewServices(
            new ProofClient(
              this.getAttribute("api-url") || "",
              this.requestHeaders,
            ),
          )
        : undefined);
    const current = (signal?: AbortSignal) =>
      this.isConnected &&
      generation === this.generation &&
      !scope.signal.aborted &&
      !signal?.aborted;
    const status = !this.currentProject
      ? "No current document supplied."
      : !this.incomingProject
        ? "No incoming revision supplied."
        : !services
          ? "Provide revision services or an explicit api-url."
          : !this.accept
            ? "Provide an onApply callback to accept the merged revision."
            : undefined;
    if (status) {
      this.root.render(React.createElement("p", { role: "status" }, status));
      return;
    }
    const project = this.project!,
      incoming = this.incoming!,
      accept = this.accept!;
    const source = services!;
    const combine = (signal?: AbortSignal) =>
      signal ? AbortSignal.any([scope.signal, signal]) : scope.signal;
    const scoped: RevisionReviewServices = {
      validateResources: async (project, signal) => {
        const joined = combine(signal);
        joined.throwIfAborted();
        await source.validateResources(structuredClone(project), joined);
        joined.throwIfAborted();
      },
      loadAsset:
        source.loadAsset &&
        (async (id, signal) => {
          const joined = combine(signal);
          joined.throwIfAborted();
          const bytes = await source.loadAsset!(id, joined);
          joined.throwIfAborted();
          return bytes;
        }),
      transformImage:
        source.transformImage &&
        (async (id, adjustments, signal) => {
          const joined = combine(signal);
          joined.throwIfAborted();
          const bytes = await source.transformImage!(
            id,
            structuredClone(adjustments),
            joined,
          );
          joined.throwIfAborted();
          return bytes;
        }),
      loadFont:
        source.loadFont &&
        (async (face, signal) => {
          const joined = combine(signal);
          joined.throwIfAborted();
          const bytes = await source.loadFont!(structuredClone(face), joined);
          joined.throwIfAborted();
          return bytes;
        }),
      assetUrl: source.assetUrl && ((id) => source.assetUrl!(id)),
    };
    this.root.render(
      React.createElement(ProjectRevisionReview, {
        key: generation,
        project,
        baseline: this.baseline,
        incoming,
        importReport: this.importReport,
        services: scoped,
        onApply: async (
          candidate: Project,
          review: RevisionReviewReport,
          signal: AbortSignal,
        ) => {
          const combined = AbortSignal.any([scope.signal, signal]);
          combined.throwIfAborted();
          const event = {
            project: structuredClone(candidate),
            report: structuredClone(review),
          };
          await accept(
            structuredClone(candidate),
            structuredClone(review),
            combined,
          );
          if (current(combined))
            this.dispatchEvent(
              new CustomEvent("proof:revision", {
                detail: event,
                bubbles: true,
                composed: true,
              }),
            );
        },
        onCancel: () => {
          if (current()) {
            scope.abort();
            this.dispatchEvent(
              new CustomEvent("proof:cancel", {
                bubbles: true,
                composed: true,
              }),
            );
          }
        },
        onChooseRevision: () => {
          if (current()) {
            scope.abort();
            this.dispatchEvent(
              new CustomEvent("proof:choose-revision", {
                bubbles: true,
                composed: true,
              }),
            );
          }
        },
        onReportDownload: (report: RevisionReviewReport) => {
          if (!current()) return;
          const copy = structuredClone(report);
          const accepted = this.dispatchEvent(
            new CustomEvent("proof:revision-report", {
              detail: structuredClone(copy),
              bubbles: true,
              composed: true,
              cancelable: true,
            }),
          );
          if (current() && accepted && this.settings.downloadReport !== false)
            downloadRevisionReview(copy);
        },
      }),
    );
  }
}
export function registerProofRevisionReview() {
  if (
    typeof customElements !== "undefined" &&
    !customElements.get("proof-revision-review")
  )
    customElements.define("proof-revision-review", ProofRevisionReviewElement);
}

/** Explicit transport for managed-font catalog widgets. */
export function fontLibraryServices(
  client: Pick<
    ProofClient,
    "listFonts" | "loadFont" | "uploadFont" | "archiveFont"
  >,
): FontLibraryServices {
  return {
    listFonts: (signal) => client.listFonts(signal),
    loadFont: (face, signal) => client.loadFont(face, signal, 64000000),
    uploadFont: (file, signal) => client.uploadFont(file, file.name, signal),
    archiveFont: (id, signal) => client.archiveFont(id, signal),
  };
}
export interface FontLibraryElementOptions {
  canApply?: boolean;
  download?: boolean;
}
export class ProofFontLibraryElement extends ElementBase {
  static get observedAttributes() {
    return ["api-url"];
  }
  private root?: Root;
  private definition?: Project;
  private adapters?: FontLibraryServices;
  private requestHeaders: Record<string, string> = {};
  private settings: FontLibraryElementOptions = {};
  private generation = 0;
  private scope?: AbortController;
  connectedCallback() {
    if (!this.shadowRoot) {
      const shadow = this.attachShadow({ mode: "open" }),
        style = document.createElement("style"),
        mount = document.createElement("div");
      style.textContent = authoringStyles;
      mount.dataset.fontLibraryMount = "";
      style.textContent += ":host{display:block;min-width:0}";
      shadow.append(style, mount);
    }
    this.root ||= createRoot(
      this.shadowRoot!.querySelector<HTMLDivElement>(
        "[data-font-library-mount]",
      )!,
    );
    this.reload();
  }
  disconnectedCallback() {
    this.generation++;
    this.scope?.abort();
    this.root?.unmount();
    this.root = undefined;
  }
  attributeChangedCallback() {
    this.reload();
  }
  set project(value: Project | undefined) {
    this.definition = undefined;
    try {
      this.definition = value && parseProject(structuredClone(value));
    } finally {
      this.reload();
    }
  }
  get project() {
    return this.definition && structuredClone(this.definition);
  }
  set services(value: FontLibraryServices | undefined) {
    this.adapters = undefined;
    try {
      this.adapters = value && bindFontLibraryServices(value);
    } finally {
      this.reload();
    }
  }
  get services() {
    return this.adapters && { ...this.adapters };
  }
  set headers(value: Record<string, string>) {
    this.requestHeaders = { ...value };
    this.reload();
  }
  get headers() {
    return { ...this.requestHeaders };
  }
  set options(value: FontLibraryElementOptions) {
    if (
      !value ||
      typeof value !== "object" ||
      (value.canApply !== undefined && typeof value.canApply !== "boolean") ||
      (value.download !== undefined && typeof value.download !== "boolean")
    )
      throw new TypeError("Choose valid font library options");
    this.settings = { ...value };
    this.reload();
  }
  get options() {
    return { ...this.settings };
  }
  reload() {
    this.generation++;
    this.scope?.abort();
    this.render();
  }
  private render() {
    integrationDesignMode(this);
    if (!this.root) return;
    const generation = this.generation,
      scope = new AbortController();
    this.scope = scope;
    const source =
      this.adapters ||
      (this.hasAttribute("api-url")
        ? fontLibraryServices(
            new ProofClient(
              this.getAttribute("api-url") || "",
              this.requestHeaders,
            ),
          )
        : undefined);
    if (!this.definition || !source) {
      this.root.render(
        React.createElement(
          "p",
          { role: "status" },
          !this.definition
            ? "No document supplied."
            : "Provide font services or an explicit api-url.",
        ),
      );
      return;
    }
    const current = (signal?: AbortSignal) =>
      this.isConnected &&
      generation === this.generation &&
      !scope.signal.aborted &&
      !signal?.aborted;
    const joined = (signal: AbortSignal) => {
      const result = AbortSignal.any([scope.signal, signal]);
      result.throwIfAborted();
      return result;
    };
    const services: FontLibraryServices = {
      listFonts: async (signal) => {
        const combined = joined(signal);
        const value = await source.listFonts(combined);
        combined.throwIfAborted();
        return value;
      },
      loadFont: async (face, signal) => {
        const combined = joined(signal);
        const value = await source.loadFont(structuredClone(face), combined);
        combined.throwIfAborted();
        return value;
      },
      ...(source.uploadFont && {
        uploadFont: async (file: File, signal: AbortSignal) => {
          const combined = joined(signal);
          const value = await source.uploadFont!(file, combined);
          combined.throwIfAborted();
          return value;
        },
      }),
      ...(source.archiveFont && {
        archiveFont: async (id: string, signal: AbortSignal) => {
          const combined = joined(signal);
          const value = await source.archiveFont!(id, combined);
          combined.throwIfAborted();
          return value;
        },
      }),
    };
    this.root.render(
      React.createElement(FontLibrary, {
        key: JSON.stringify([this.definition.tenantId, this.definition.id]),
        project: this.project!,
        services,
        canApply: this.settings.canApply,
        onChange: (project: Project) => {
          if (!current() || this.settings.canApply === false) return;
          this.definition = parseProject(structuredClone(project));
          this.dispatchEvent(
            new CustomEvent("proof:change", {
              detail: { project: this.project, reason: "font-style" },
              bubbles: true,
              composed: true,
            }),
          );
          if (current()) this.reload();
        },
        notify: (message: string) => {
          if (current())
            this.dispatchEvent(
              new CustomEvent("proof:notice", {
                detail: { message },
                bubbles: true,
                composed: true,
              }),
            );
        },
        onDownload: (artifact: FontLibraryArtifact, signal: AbortSignal) => {
          if (!current(signal)) return;
          const accepted = this.dispatchEvent(
            new CustomEvent("proof:font", {
              detail: { ...artifact, record: structuredClone(artifact.record) },
              bubbles: true,
              composed: true,
              cancelable: true,
            }),
          );
          if (current(signal) && accepted && this.settings.download !== false)
            downloadFontLibraryFace(artifact);
        },
      }),
    );
  }
}
export function registerProofFontLibrary() {
  if (
    typeof customElements !== "undefined" &&
    !customElements.get("proof-font-library")
  )
    customElements.define("proof-font-library", ProofFontLibraryElement);
}

export function assetLibraryServices(
  client: Pick<ProofClient, "listAssets" | "loadAsset" | "uploadAsset">,
  projectId?: string,
): AssetLibraryServices {
  return {
    listAssets: (signal) => client.listAssets.call(client, signal, projectId),
    loadAsset: (id, signal) => client.loadAsset.call(client, id, signal),
    uploadAsset: (file, signal, scope) =>
      client.uploadAsset.call(
        client,
        file,
        file.name,
        signal,
        scope === "shared" ? undefined : projectId,
      ),
  };
}
export interface AssetLibraryElementOptions {
  canApply?: boolean;
  canUpload?: boolean;
  download?: boolean;
  initialScope?: "project" | "shared";
}
export class ProofAssetLibraryElement extends ElementBase {
  static get observedAttributes() {
    return ["api-url", "tenant-id"];
  }
  private root?: Root;
  private definition?: Project;
  private adapters?: AssetLibraryServices;
  private requestHeaders: Record<string, string> = {};
  private settings: AssetLibraryElementOptions = {};
  private generation = 0;
  private scope?: AbortController;
  connectedCallback() {
    if (!this.shadowRoot) {
      const shadow = this.attachShadow({ mode: "open" }),
        style = this.ownerDocument.createElement("style"),
        mount = this.ownerDocument.createElement("div");
      style.textContent = authoringStyles + ":host{display:block;min-width:0}";
      mount.dataset.assetLibraryMount = "";
      shadow.append(style, mount);
    }
    this.root ||= createRoot(
      this.shadowRoot!.querySelector<HTMLDivElement>(
        "[data-asset-library-mount]",
      )!,
    );
    this.reload();
  }
  disconnectedCallback() {
    this.generation++;
    this.scope?.abort();
    this.root?.unmount();
    this.root = undefined;
  }
  attributeChangedCallback() {
    this.reload();
  }
  set project(value: Project | undefined) {
    this.definition = undefined;
    try {
      this.definition = value && parseProject(structuredClone(value));
    } finally {
      this.reload();
    }
  }
  get project() {
    return this.definition && structuredClone(this.definition);
  }
  set tenantId(value: string) {
    if (typeof value !== "string" || !value.trim() || value.length > 200)
      throw new TypeError("Provide a workspace identity");
    this.setAttribute("tenant-id", value);
  }
  get tenantId() {
    return this.getAttribute("tenant-id") || this.definition?.tenantId || "";
  }
  set services(value: AssetLibraryServices | undefined) {
    this.adapters = undefined;
    try {
      this.adapters = value && bindAssetLibraryServices(value);
    } finally {
      this.reload();
    }
  }
  get services() {
    return this.adapters && { ...this.adapters };
  }
  set headers(value: Record<string, string>) {
    this.requestHeaders = { ...value };
    this.reload();
  }
  get headers() {
    return { ...this.requestHeaders };
  }
  set options(value: AssetLibraryElementOptions) {
    if (
      !value ||
      typeof value !== "object" ||
      ["canApply", "canUpload", "download"].some(
        (key) =>
          value[key as "canApply"] !== undefined &&
          typeof value[key as "canApply"] !== "boolean",
      ) ||
      (value.initialScope !== undefined &&
        !["project", "shared"].includes(value.initialScope))
    )
      throw new TypeError("Choose valid asset library options");
    this.settings = { ...value };
    this.reload();
  }
  get options() {
    return { ...this.settings };
  }
  reload() {
    this.generation++;
    this.scope?.abort();
    this.render();
  }
  private render() {
    integrationDesignMode(this);
    if (!this.root) return;
    const generation = this.generation,
      scope = new AbortController();
    this.scope = scope;
    const source =
      this.adapters ||
      (this.hasAttribute("api-url")
        ? assetLibraryServices(
            new ProofClient(
              this.getAttribute("api-url") || "",
              this.requestHeaders,
            ),
            this.definition?.id,
          )
        : undefined);
    if (!this.tenantId || !source) {
      this.root.render(
        React.createElement(
          "p",
          { role: "status" },
          !this.tenantId
            ? "Provide a workspace identity or document."
            : "Provide asset services or an explicit api-url.",
        ),
      );
      return;
    }
    const current = (signal?: AbortSignal) =>
      this.isConnected &&
      generation === this.generation &&
      !scope.signal.aborted &&
      !signal?.aborted;
    const joined = (signal: AbortSignal) => {
      const combined = AbortSignal.any([scope.signal, signal]);
      combined.throwIfAborted();
      return combined;
    };
    const services: AssetLibraryServices = {
      listAssets: async (signal) => {
        const combined = joined(signal),
          rows = await source.listAssets(combined);
        combined.throwIfAborted();
        return rows;
      },
      loadAsset: async (id, signal) => {
        const combined = joined(signal),
          blob = await source.loadAsset(id, combined);
        combined.throwIfAborted();
        return blob;
      },
      ...(source.uploadAsset && {
        uploadAsset: async (
          file: File,
          signal: AbortSignal,
          libraryScope?: "project" | "shared",
        ) => {
          const combined = joined(signal),
            row = await source.uploadAsset!(file, combined, libraryScope);
          combined.throwIfAborted();
          return row;
        },
      }),
    };
    const sharedProps = {
      tenantId: this.tenantId,
      services,
      canApply: this.settings.canApply,
      canUpload: this.settings.canUpload,
      initialScope: this.settings.initialScope,
      onChange: (project: Project) => {
        if (!current() || !this.definition || this.settings.canApply === false)
          return;
        this.definition = parseProject(structuredClone(project));
        this.dispatchEvent(
          new CustomEvent("proof:change", {
            detail: { project: this.project, reason: "asset-library" },
            bubbles: true,
            composed: true,
          }),
        );
        if (current()) paint();
      },
      notify: (message: string) => {
        if (current())
          this.dispatchEvent(
            new CustomEvent("proof:notice", {
              detail: { message },
              bubbles: true,
              composed: true,
            }),
          );
      },
      onDownload: (artifact: AssetLibraryArtifact, signal: AbortSignal) => {
        if (!current(signal)) return;
        const accepted = this.dispatchEvent(
          new CustomEvent("proof:asset", {
            detail: { ...artifact, record: structuredClone(artifact.record) },
            bubbles: true,
            composed: true,
            cancelable: true,
          }),
        );
        if (current(signal) && accepted && this.settings.download !== false)
          downloadLibraryAsset(artifact, this.ownerDocument);
      },
    };
    const paint = () => {
      if (current())
        this.root!.render(
          React.createElement(AssetLibrary, {
            ...sharedProps,
            project: this.project,
            key: JSON.stringify([this.tenantId, this.definition?.id]),
          }),
        );
    };
    paint();
  }
}
export function registerProofAssetLibrary() {
  if (
    typeof customElements !== "undefined" &&
    !customElements.get("proof-asset-library")
  )
    customElements.define("proof-asset-library", ProofAssetLibraryElement);
}

/** Explicit HTTP adapter; callback-only widgets do not construct a client. */
export function bulkGenerationServices(
  client: Pick<ProofClient, "request" | "loadGenerationArtifact">,
  options: { mode?: "demo" | "published" } = {},
): BulkGenerationServices {
  const mode = options.mode || "published";
  const scope = (input: import("@proof/authoring").BulkContextInput) => {
    if (mode === "published" && !input.versionId)
      throw new Error("Choose a published document version before generating");
    return {
      ...(mode === "demo"
        ? {
            project: input.project,
            ...(input.contextProfile
              ? { demoProfile: input.contextProfile }
              : {}),
          }
        : { projectId: input.project.id, versionId: input.versionId }),
      partId: input.partId,
      sourceParameters: input.sourceParameters,
    };
  };
  const generate = (
    path: string,
    input: BulkGenerationInput,
    signal: AbortSignal,
  ) =>
    client.request.call(client, path, {
      method: "POST",
      signal,
      body: JSON.stringify({
        ...scope(input),
        ...(mode === "demo"
          ? { profile: input.profile }
          : { profileId: input.profile.id }),
        contextHash: input.contextHash,
        batch: input.batch,
      }),
    });
  return {
    listBatches: (signal) =>
      client.request.call(client, "/batches", { signal }) as Promise<
        BulkBatchView[]
      >,
    readBatch: (id, signal) =>
      client.request.call(client, `/batches/${encodeURIComponent(id)}`, {
        signal,
      }) as Promise<BulkBatchView>,
    readDefinition: (id, signal) =>
      client.request.call(
        client,
        `/batches/${encodeURIComponent(id)}/definition`,
        { signal },
      ) as Promise<BulkBatchDefinition>,
    createBatch: (input, signal) =>
      generate("/batches", input, signal) as Promise<BulkBatchView>,
    prepareImages: (input, signal) =>
      generate(
        "/batches/prepare",
        input,
        signal,
      ) as Promise<BulkPreparedImages>,
    resolveContext: (input, signal) =>
      client.request.call(client, "/context-preview", {
        method: "POST",
        signal,
        body: JSON.stringify({
          ...scope(input),
          forceRefresh: input.forceRefresh,
        }),
      }) as Promise<{ context: Context; hash?: string }>,
    cancelBatch: (id, stateVersion, signal) =>
      client.request.call(client, `/batches/${encodeURIComponent(id)}/cancel`, {
        method: "POST",
        signal,
        body: JSON.stringify({
          stateVersion,
          reason: "Batch cancelled by user",
        }),
      }) as Promise<BulkBatchView>,
    retryRows: (id, stateVersion, rowKeys, signal) =>
      client.request.call(client, `/batches/${encodeURIComponent(id)}/retry`, {
        method: "POST",
        signal,
        body: JSON.stringify({
          stateVersion,
          rowKeys,
          reason: "Reviewed failed record",
        }),
      }) as Promise<BulkBatchView>,
    loadArtifact: (id, signal) =>
      client.loadGenerationArtifact.call(client, id, signal),
  };
}
export interface BulkGenerationElementOptions {
  mode?: "demo" | "published";
  versionId?: string;
  download?: boolean;
  contextProfiles?: { id: string; label: string }[];
  initialContextProfile?: string;
}
/** Full import, mapping, proof review and durable batch workflow for plain JavaScript hosts. */
export class ProofBulkGenerationElement extends ElementBase {
  static get observedAttributes() {
    return ["api-url", "tenant-id", "design-mode"];
  }
  private root?: Root;
  private definition?: Project;
  private adapters?: BulkGenerationServices;
  private previews?: BulkGenerationProps["proofServices"];
  private sessionStore?: BulkSessionStore;
  private settings: BulkGenerationElementOptions = {};
  private requestHeaders: Record<string, string> = {};
  private generation = 0;
  private scope?: AbortController;
  connectedCallback() {
    if (!this.shadowRoot) {
      const shadow = this.attachShadow({ mode: "open" }),
        style = this.ownerDocument.createElement("style"),
        mount = this.ownerDocument.createElement("div");
      style.textContent = authoringStyles + ":host{display:block;min-width:0}";
      mount.dataset.bulkGenerationMount = "";
      shadow.append(style, mount);
    }
    this.root ||= createRoot(
      this.shadowRoot!.querySelector<HTMLDivElement>(
        "[data-bulk-generation-mount]",
      )!,
    );
    this.reload();
  }
  disconnectedCallback() {
    this.generation++;
    this.scope?.abort();
    this.root?.unmount();
    this.root = undefined;
  }
  attributeChangedCallback() {
    this.reload();
  }
  set project(value: Project | undefined) {
    this.definition = undefined;
    try {
      this.definition = value && parseProject(structuredClone(value));
    } finally {
      this.reload();
    }
  }
  get project() {
    return this.definition && structuredClone(this.definition);
  }
  set tenantId(value: string) {
    if (typeof value !== "string" || !value.trim() || value.length > 200)
      throw new TypeError("Provide a workspace identity");
    this.setAttribute("tenant-id", value);
  }
  get tenantId() {
    return this.getAttribute("tenant-id") || this.definition?.tenantId || "";
  }
  set services(value: BulkGenerationServices | undefined) {
    this.adapters = undefined;
    try {
      this.adapters = value && bindBulkGenerationServices(value);
    } finally {
      this.reload();
    }
  }
  get services() {
    return this.adapters && { ...this.adapters };
  }
  set session(value: BulkSessionStore | undefined) {
    this.sessionStore = undefined;
    try {
      this.sessionStore = value && bindBulkSessionStore(value);
    } finally {
      this.reload();
    }
  }
  get session() {
    return this.sessionStore && { ...this.sessionStore };
  }
  set proofServices(value: BulkGenerationProps["proofServices"]) {
    this.previews = undefined;
    try {
      if (value) {
        const bound: Record<string, Function> = {};
        for (const key of [
          "assetUrl",
          "loadAsset",
          "transformImage",
          "loadFont",
        ] as const) {
          const callback = value[key];
          if (callback !== undefined && typeof callback !== "function")
            throw new TypeError("Provide preview callbacks");
          if (callback)
            bound[key] = (...args: unknown[]) =>
              (callback as Function).apply(value, args);
        }
        this.previews = bound;
      }
    } finally {
      this.reload();
    }
  }
  get proofServices() {
    return this.previews && { ...this.previews };
  }
  set headers(value: Record<string, string>) {
    this.requestHeaders = requestHeaders(value);
    this.reload();
  }
  get headers() {
    return { ...this.requestHeaders };
  }
  set options(value: BulkGenerationElementOptions) {
    if (
      !value ||
      typeof value !== "object" ||
      (value.mode !== undefined &&
        !["demo", "published"].includes(value.mode)) ||
      (value.download !== undefined && typeof value.download !== "boolean") ||
      (value.versionId !== undefined &&
        (typeof value.versionId !== "string" ||
          !value.versionId ||
          value.versionId.length > 200)) ||
      (value.initialContextProfile !== undefined &&
        typeof value.initialContextProfile !== "string") ||
      (value.contextProfiles !== undefined &&
        (!Array.isArray(value.contextProfiles) ||
          value.contextProfiles.length > 1000 ||
          value.contextProfiles.some(
            (row) =>
              !row ||
              typeof row.id !== "string" ||
              !row.id ||
              row.id.length > 200 ||
              typeof row.label !== "string" ||
              row.label.length > 200,
          ) ||
          new Set(value.contextProfiles.map((row) => row.id)).size !==
            value.contextProfiles.length))
    )
      throw new TypeError("Choose valid bulk-generation options");
    this.settings = structuredClone(value);
    this.reload();
  }
  get options() {
    return structuredClone(this.settings);
  }
  reload() {
    this.generation++;
    this.scope?.abort();
    if (!this.root) return;
    integrationDesignMode(this);
    const generation = this.generation,
      controller = new AbortController();
    this.scope = controller;
    const client = this.hasAttribute("api-url")
      ? new ProofClient(this.getAttribute("api-url") || "", this.requestHeaders)
      : undefined;
    const source =
      this.adapters ||
      (client && bulkGenerationServices(client, { mode: this.settings.mode }));
    if (
      !this.definition ||
      this.definition.tenantId !== this.tenantId ||
      !source
    ) {
      this.root.render(
        React.createElement(
          "p",
          { role: "status" },
          !this.definition || this.definition.tenantId !== this.tenantId
            ? "Provide a document for this workspace."
            : "Provide bulk-generation services or an explicit api-url.",
        ),
      );
      return;
    }
    const current = (signal?: AbortSignal) =>
      this.isConnected &&
      generation === this.generation &&
      !controller.signal.aborted &&
      !signal?.aborted;
    const services: Record<string, Function> = {};
    for (const name of [
      "listBatches",
      "readBatch",
      "readDefinition",
      "createBatch",
      "prepareImages",
      "resolveContext",
      "cancelBatch",
      "retryRows",
      "loadArtifact",
    ] as const) {
      const callback = source[name];
      if (!callback) continue;
      services[name] = async (...args: unknown[]) => {
        const signal = AbortSignal.any([
          args.at(-1) as AbortSignal,
          controller.signal,
        ]);
        signal.throwIfAborted();
        const result = await (callback as Function).apply(source, [
          ...args.slice(0, -1),
          signal,
        ]);
        signal.throwIfAborted();
        return result;
      };
    }
    const proofServices =
      this.previews ||
      (client && {
        loadAsset: (id: string, signal: AbortSignal) =>
          client.loadAsset(id, signal),
        transformImage: (
          id: string,
          adjustments: Adjustments,
          signal: AbortSignal,
        ) => client.transformAsset(id, adjustments, signal),
        loadFont: (face: FontFaceDescriptor, signal?: AbortSignal) =>
          client.loadFont(face, signal),
      });
    this.root.render(
      React.createElement(BulkGeneration, {
        key: generation,
        project: this.project!,
        versionId: this.settings.versionId,
        services: services as unknown as BulkGenerationServices,
        session: this.sessionStore,
        proofServices,
        contextProfiles: this.settings.contextProfiles,
        initialContextProfile: this.settings.initialContextProfile,
        notify: (message: string) => {
          if (current())
            this.dispatchEvent(
              new CustomEvent("proof:notice", {
                detail: { message },
                bubbles: true,
                composed: true,
              }),
            );
        },
        onBatchChange: (batch: BulkBatchView) => {
          if (current())
            this.dispatchEvent(
              new CustomEvent("proof:batch", {
                detail: { batch: structuredClone(batch) },
                bubbles: true,
                composed: true,
              }),
            );
        },
        onDownload: (artifact: BulkDownload, signal: AbortSignal) => {
          if (!current(signal)) return;
          const accepted = this.dispatchEvent(
            new CustomEvent("proof:bulk-download", {
              detail: { ...artifact },
              bubbles: true,
              composed: true,
              cancelable: true,
            }),
          );
          if (current(signal) && accepted && this.settings.download !== false)
            downloadBulkArtifact(artifact, this.ownerDocument);
        },
      }),
    );
  }
}
export function registerProofBulkGeneration() {
  if (
    typeof customElements !== "undefined" &&
    !customElements.get("proof-bulk-generation")
  )
    customElements.define("proof-bulk-generation", ProofBulkGenerationElement);
}
export {
  ProofEsmProjectElement,
  registerProofEsmProject,
} from "./esm-project-element";
export { EsmProjectSession } from "@proof/legacy";
export { EsmProjectEditor, type EsmProjectEditorProps } from "@proof/authoring";
